export default {
  "chain": {
    "id": 11155931,
    "name": "RISE Testnet",
    "nativeCurrency": {
      "name": "RISE Testnet Ether",
      "symbol": "ETH",
      "decimals": 18
    },
    "rpcUrls": {
      "default": {
        "http": [
          "https://testnet.riselabs.xyz"
        ],
        "webSocket": [
          "wss://testnet.riselabs.xyz/ws"
        ]
      }
    },
    "blockExplorers": {
      "default": {
        "name": "Blockscout",
        "url": "https://explorer.testnet.riselabs.xyz/",
        "apiUrl": "https://explorer.testnet.riselabs.xyz/api"
      }
    },
    "contracts": {
      "multicall3": {
        "address": "0xca11bde05977b3631167028862be2a173976ca11"
      }
    },
    "testnet": true,
    "genesisHash": "0x3e679422992f508295d1f143e78f24d0ecd67d3228133085491842ba816eecc3",
    "properties": {
      "supportsSendRawTransactionSync": true,
      "expectedWorstGasPrice": "10000"
    }
  },
  "contracts": {
    "Avatars": {
      "abi": [
        {
          "inputs": [],
          "stateMutability": "nonpayable",
          "type": "constructor"
        },
        {
          "inputs": [
            {
              "internalType": "address",
              "name": "owner",
              "type": "address"
            },
            {
              "internalType": "uint256",
              "name": "index",
              "type": "uint256"
            }
          ],
          "name": "ERC721OutOfBoundsIndex",
          "type": "error"
        },
        {
          "inputs": [
            {
              "internalType": "address",
              "name": "addr",
              "type": "address"
            }
          ],
          "name": "InvalidAddress",
          "type": "error"
        },
        {
          "inputs": [
            {
              "internalType": "uint256",
              "name": "tokenID",
              "type": "uint256"
            }
          ],
          "name": "NonExistentToken",
          "type": "error"
        },
        {
          "inputs": [],
          "name": "NonceOverflow",
          "type": "error"
        },
        {
          "inputs": [],
          "name": "NotAuthorized",
          "type": "error"
        },
        {
          "inputs": [
            {
              "internalType": "address",
              "name": "provided",
              "type": "address"
            },
            {
              "internalType": "address",
              "name": "currentOwner",
              "type": "address"
            }
          ],
          "name": "NotOwner",
          "type": "error"
        },
        {
          "inputs": [
            {
              "internalType": "uint256",
              "name": "tokenID",
              "type": "uint256"
            }
          ],
          "name": "TokenAlreadyExists",
          "type": "error"
        },
        {
          "inputs": [
            {
              "internalType": "uint256",
              "name": "tokenID",
              "type": "uint256"
            }
          ],
          "name": "TokenCannotBeReminted",
          "type": "error"
        },
        {
          "inputs": [],
          "name": "TransferRejected",
          "type": "error"
        },
        {
          "anonymous": false,
          "inputs": [
            {
              "indexed": true,
              "internalType": "address",
              "name": "owner",
              "type": "address"
            },
            {
              "indexed": true,
              "internalType": "address",
              "name": "approved",
              "type": "address"
            },
            {
              "indexed": true,
              "internalType": "uint256",
              "name": "tokenID",
              "type": "uint256"
            }
          ],
          "name": "Approval",
          "type": "event"
        },
        {
          "anonymous": false,
          "inputs": [
            {
              "indexed": true,
              "internalType": "address",
              "name": "owner",
              "type": "address"
            },
            {
              "indexed": true,
              "internalType": "address",
              "name": "operator",
              "type": "address"
            },
            {
              "indexed": false,
              "internalType": "bool",
              "name": "approved",
              "type": "bool"
            }
          ],
          "name": "ApprovalForAll",
          "type": "event"
        },
        {
          "anonymous": false,
          "inputs": [
            {
              "indexed": true,
              "internalType": "address",
              "name": "from",
              "type": "address"
            },
            {
              "indexed": true,
              "internalType": "address",
              "name": "to",
              "type": "address"
            },
            {
              "indexed": true,
              "internalType": "uint256",
              "name": "tokenID",
              "type": "uint256"
            }
          ],
          "name": "Transfer",
          "type": "event"
        },
        {
          "inputs": [
            {
              "internalType": "address",
              "name": "operator",
              "type": "address"
            },
            {
              "internalType": "uint256",
              "name": "tokenID",
              "type": "uint256"
            }
          ],
          "name": "approve",
          "outputs": [],
          "stateMutability": "nonpayable",
          "type": "function"
        },
        {
          "inputs": [
            {
              "internalType": "address",
              "name": "owner",
              "type": "address"
            }
          ],
          "name": "balanceOf",
          "outputs": [
            {
              "internalType": "uint256",
              "name": "balance",
              "type": "uint256"
            }
          ],
          "stateMutability": "view",
          "type": "function"
        },
        {
          "inputs": [
            {
              "internalType": "uint256",
              "name": "tokenID",
              "type": "uint256"
            }
          ],
          "name": "getApproved",
          "outputs": [
            {
              "internalType": "address",
              "name": "operator",
              "type": "address"
            }
          ],
          "stateMutability": "view",
          "type": "function"
        },
        {
          "inputs": [
            {
              "internalType": "address",
              "name": "owner",
              "type": "address"
            },
            {
              "internalType": "address",
              "name": "operator",
              "type": "address"
            }
          ],
          "name": "isApprovedForAll",
          "outputs": [
            {
              "internalType": "bool",
              "name": "isOperator",
              "type": "bool"
            }
          ],
          "stateMutability": "view",
          "type": "function"
        },
        {
          "inputs": [
            {
              "internalType": "address",
              "name": "to",
              "type": "address"
            },
            {
              "internalType": "uint256",
              "name": "tokenID",
              "type": "uint256"
            },
            {
              "internalType": "bytes",
              "name": "data",
              "type": "bytes"
            }
          ],
          "name": "mint",
          "outputs": [],
          "stateMutability": "payable",
          "type": "function"
        },
        {
          "inputs": [
            {
              "internalType": "uint256[]",
              "name": "tokenIDs",
              "type": "uint256[]"
            }
          ],
          "name": "ownerAndLastTransferBlockNumberList",
          "outputs": [
            {
              "components": [
                {
                  "internalType": "address",
                  "name": "owner",
                  "type": "address"
                },
                {
                  "internalType": "uint256",
                  "name": "lastTransferBlockNumber",
                  "type": "uint256"
                }
              ],
              "internalType": "struct IERC721WithBlocknumber.OwnerData[]",
              "name": "ownersData",
              "type": "tuple[]"
            }
          ],
          "stateMutability": "view",
          "type": "function"
        },
        {
          "inputs": [
            {
              "internalType": "uint256",
              "name": "tokenID",
              "type": "uint256"
            }
          ],
          "name": "ownerAndLastTransferBlockNumberOf",
          "outputs": [
            {
              "internalType": "address",
              "name": "owner",
              "type": "address"
            },
            {
              "internalType": "uint256",
              "name": "blockNumber",
              "type": "uint256"
            }
          ],
          "stateMutability": "view",
          "type": "function"
        },
        {
          "inputs": [
            {
              "internalType": "uint256",
              "name": "tokenID",
              "type": "uint256"
            }
          ],
          "name": "ownerOf",
          "outputs": [
            {
              "internalType": "address",
              "name": "owner",
              "type": "address"
            }
          ],
          "stateMutability": "view",
          "type": "function"
        },
        {
          "inputs": [
            {
              "internalType": "address",
              "name": "from",
              "type": "address"
            },
            {
              "internalType": "address",
              "name": "to",
              "type": "address"
            },
            {
              "internalType": "uint256",
              "name": "tokenID",
              "type": "uint256"
            }
          ],
          "name": "safeTransferFrom",
          "outputs": [],
          "stateMutability": "nonpayable",
          "type": "function"
        },
        {
          "inputs": [
            {
              "internalType": "address",
              "name": "from",
              "type": "address"
            },
            {
              "internalType": "address",
              "name": "to",
              "type": "address"
            },
            {
              "internalType": "uint256",
              "name": "tokenID",
              "type": "uint256"
            },
            {
              "internalType": "bytes",
              "name": "data",
              "type": "bytes"
            }
          ],
          "name": "safeTransferFrom",
          "outputs": [],
          "stateMutability": "nonpayable",
          "type": "function"
        },
        {
          "inputs": [
            {
              "internalType": "address",
              "name": "operator",
              "type": "address"
            },
            {
              "internalType": "bool",
              "name": "approved",
              "type": "bool"
            }
          ],
          "name": "setApprovalForAll",
          "outputs": [],
          "stateMutability": "nonpayable",
          "type": "function"
        },
        {
          "inputs": [
            {
              "internalType": "bytes4",
              "name": "interfaceId",
              "type": "bytes4"
            }
          ],
          "name": "supportsInterface",
          "outputs": [
            {
              "internalType": "bool",
              "name": "",
              "type": "bool"
            }
          ],
          "stateMutability": "view",
          "type": "function"
        },
        {
          "inputs": [
            {
              "internalType": "uint256",
              "name": "index",
              "type": "uint256"
            }
          ],
          "name": "tokenByIndex",
          "outputs": [
            {
              "internalType": "uint256",
              "name": "",
              "type": "uint256"
            }
          ],
          "stateMutability": "view",
          "type": "function"
        },
        {
          "inputs": [
            {
              "internalType": "address",
              "name": "owner",
              "type": "address"
            },
            {
              "internalType": "uint256",
              "name": "index",
              "type": "uint256"
            }
          ],
          "name": "tokenOfOwnerByIndex",
          "outputs": [
            {
              "internalType": "uint256",
              "name": "",
              "type": "uint256"
            }
          ],
          "stateMutability": "view",
          "type": "function"
        },
        {
          "inputs": [
            {
              "internalType": "address",
              "name": "owner",
              "type": "address"
            },
            {
              "internalType": "uint256",
              "name": "index",
              "type": "uint256"
            },
            {
              "internalType": "uint256",
              "name": "limit",
              "type": "uint256"
            }
          ],
          "name": "tokensOfOwner",
          "outputs": [
            {
              "internalType": "uint256[]",
              "name": "tokenIDs",
              "type": "uint256[]"
            },
            {
              "internalType": "bool",
              "name": "more",
              "type": "bool"
            }
          ],
          "stateMutability": "view",
          "type": "function"
        },
        {
          "inputs": [],
          "name": "totalSupply",
          "outputs": [
            {
              "internalType": "uint256",
              "name": "",
              "type": "uint256"
            }
          ],
          "stateMutability": "view",
          "type": "function"
        },
        {
          "inputs": [
            {
              "internalType": "address",
              "name": "from",
              "type": "address"
            },
            {
              "internalType": "address",
              "name": "to",
              "type": "address"
            },
            {
              "internalType": "uint256",
              "name": "tokenID",
              "type": "uint256"
            }
          ],
          "name": "transferFrom",
          "outputs": [],
          "stateMutability": "nonpayable",
          "type": "function"
        }
      ],
      "address": "0x3368e40595904944e5791002cfef39bc411d9f12",
      "startBlock": 30136229
    },
    "AvatarsSale": {
      "abi": [
        {
          "inputs": [
            {
              "internalType": "contract Avatars",
              "name": "items",
              "type": "address"
            },
            {
              "components": [
                {
                  "internalType": "uint256",
                  "name": "paymentAmount",
                  "type": "uint256"
                },
                {
                  "internalType": "address payable",
                  "name": "recipient",
                  "type": "address"
                },
                {
                  "internalType": "address",
                  "name": "freeMapAdmin",
                  "type": "address"
                }
              ],
              "internalType": "struct SaleViaNativePayment.Config",
              "name": "config",
              "type": "tuple"
            }
          ],
          "stateMutability": "nonpayable",
          "type": "constructor"
        },
        {
          "inputs": [],
          "name": "ExpectNativeToken",
          "type": "error"
        },
        {
          "inputs": [
            {
              "internalType": "address",
              "name": "recipient",
              "type": "address"
            }
          ],
          "name": "FailedToTransferNativeToken",
          "type": "error"
        },
        {
          "inputs": [
            {
              "internalType": "address",
              "name": "sender",
              "type": "address"
            },
            {
              "internalType": "address",
              "name": "expected",
              "type": "address"
            }
          ],
          "name": "NotFreeMapAdmin",
          "type": "error"
        },
        {
          "inputs": [
            {
              "internalType": "contract IERC20",
              "name": "token",
              "type": "address"
            },
            {
              "internalType": "address",
              "name": "from",
              "type": "address"
            },
            {
              "internalType": "address",
              "name": "to",
              "type": "address"
            },
            {
              "internalType": "uint256",
              "name": "amount",
              "type": "uint256"
            }
          ],
          "name": "TransferFailed",
          "type": "error"
        },
        {
          "inputs": [
            {
              "internalType": "uint256",
              "name": "amount",
              "type": "uint256"
            },
            {
              "internalType": "uint256",
              "name": "expected",
              "type": "uint256"
            }
          ],
          "name": "WrongPaymentAmount",
          "type": "error"
        },
        {
          "anonymous": false,
          "inputs": [
            {
              "indexed": true,
              "internalType": "address",
              "name": "sender",
              "type": "address"
            },
            {
              "indexed": true,
              "internalType": "address",
              "name": "to",
              "type": "address"
            },
            {
              "indexed": true,
              "internalType": "address",
              "name": "referrer",
              "type": "address"
            },
            {
              "indexed": false,
              "internalType": "uint256",
              "name": "tokenID",
              "type": "uint256"
            }
          ],
          "name": "Mint",
          "type": "event"
        },
        {
          "inputs": [],
          "name": "FREE_MAP_ADMIN",
          "outputs": [
            {
              "internalType": "address",
              "name": "",
              "type": "address"
            }
          ],
          "stateMutability": "view",
          "type": "function"
        },
        {
          "inputs": [],
          "name": "ITEMS",
          "outputs": [
            {
              "internalType": "contract IERC721",
              "name": "",
              "type": "address"
            }
          ],
          "stateMutability": "view",
          "type": "function"
        },
        {
          "inputs": [],
          "name": "PAYMENT_AMOUNT",
          "outputs": [
            {
              "internalType": "uint256",
              "name": "",
              "type": "uint256"
            }
          ],
          "stateMutability": "view",
          "type": "function"
        },
        {
          "inputs": [],
          "name": "RECIPIENT",
          "outputs": [
            {
              "internalType": "address payable",
              "name": "",
              "type": "address"
            }
          ],
          "stateMutability": "view",
          "type": "function"
        },
        {
          "inputs": [
            {
              "internalType": "address[]",
              "name": "addresses",
              "type": "address[]"
            }
          ],
          "name": "addToFreeMap",
          "outputs": [],
          "stateMutability": "nonpayable",
          "type": "function"
        },
        {
          "inputs": [
            {
              "internalType": "address",
              "name": "",
              "type": "address"
            }
          ],
          "name": "freemap",
          "outputs": [
            {
              "internalType": "bool",
              "name": "",
              "type": "bool"
            }
          ],
          "stateMutability": "view",
          "type": "function"
        },
        {
          "inputs": [
            {
              "internalType": "address payable",
              "name": "to",
              "type": "address"
            },
            {
              "internalType": "uint96",
              "name": "subID",
              "type": "uint96"
            },
            {
              "internalType": "bytes",
              "name": "data",
              "type": "bytes"
            },
            {
              "internalType": "address payable",
              "name": "extraNativeTokenRecipient",
              "type": "address"
            },
            {
              "internalType": "uint256",
              "name": "extraNativeTokenAmount",
              "type": "uint256"
            },
            {
              "internalType": "address",
              "name": "referrer",
              "type": "address"
            }
          ],
          "name": "purchase",
          "outputs": [],
          "stateMutability": "payable",
          "type": "function"
        },
        {
          "inputs": [
            {
              "internalType": "address[]",
              "name": "addresses",
              "type": "address[]"
            }
          ],
          "name": "removeFromFreeMap",
          "outputs": [],
          "stateMutability": "nonpayable",
          "type": "function"
        }
      ],
      "address": "0x3316bad0628afa81b5657e109e71d7831b036ec0",
      "linkedData": {
        "paymentAmount": "10000000000",
        "recipient": "0x61c461ecc993aadeb7e4b47e96d1b8cc37314b20",
        "freeMapAdmin": "0x61c461ecc993aadeb7e4b47e96d1b8cc37314b20"
      },
      "startBlock": 30136242
    },
    "AvatarsSale_Implementation": {
      "abi": [
        {
          "inputs": [
            {
              "internalType": "contract Avatars",
              "name": "items",
              "type": "address"
            },
            {
              "components": [
                {
                  "internalType": "uint256",
                  "name": "paymentAmount",
                  "type": "uint256"
                },
                {
                  "internalType": "address payable",
                  "name": "recipient",
                  "type": "address"
                },
                {
                  "internalType": "address",
                  "name": "freeMapAdmin",
                  "type": "address"
                }
              ],
              "internalType": "struct SaleViaNativePayment.Config",
              "name": "config",
              "type": "tuple"
            }
          ],
          "stateMutability": "nonpayable",
          "type": "constructor"
        },
        {
          "inputs": [],
          "name": "ExpectNativeToken",
          "type": "error"
        },
        {
          "inputs": [
            {
              "internalType": "address",
              "name": "recipient",
              "type": "address"
            }
          ],
          "name": "FailedToTransferNativeToken",
          "type": "error"
        },
        {
          "inputs": [
            {
              "internalType": "address",
              "name": "sender",
              "type": "address"
            },
            {
              "internalType": "address",
              "name": "expected",
              "type": "address"
            }
          ],
          "name": "NotFreeMapAdmin",
          "type": "error"
        },
        {
          "inputs": [
            {
              "internalType": "contract IERC20",
              "name": "token",
              "type": "address"
            },
            {
              "internalType": "address",
              "name": "from",
              "type": "address"
            },
            {
              "internalType": "address",
              "name": "to",
              "type": "address"
            },
            {
              "internalType": "uint256",
              "name": "amount",
              "type": "uint256"
            }
          ],
          "name": "TransferFailed",
          "type": "error"
        },
        {
          "inputs": [
            {
              "internalType": "uint256",
              "name": "amount",
              "type": "uint256"
            },
            {
              "internalType": "uint256",
              "name": "expected",
              "type": "uint256"
            }
          ],
          "name": "WrongPaymentAmount",
          "type": "error"
        },
        {
          "anonymous": false,
          "inputs": [
            {
              "indexed": true,
              "internalType": "address",
              "name": "sender",
              "type": "address"
            },
            {
              "indexed": true,
              "internalType": "address",
              "name": "to",
              "type": "address"
            },
            {
              "indexed": true,
              "internalType": "address",
              "name": "referrer",
              "type": "address"
            },
            {
              "indexed": false,
              "internalType": "uint256",
              "name": "tokenID",
              "type": "uint256"
            }
          ],
          "name": "Mint",
          "type": "event"
        },
        {
          "inputs": [],
          "name": "FREE_MAP_ADMIN",
          "outputs": [
            {
              "internalType": "address",
              "name": "",
              "type": "address"
            }
          ],
          "stateMutability": "view",
          "type": "function"
        },
        {
          "inputs": [],
          "name": "ITEMS",
          "outputs": [
            {
              "internalType": "contract IERC721",
              "name": "",
              "type": "address"
            }
          ],
          "stateMutability": "view",
          "type": "function"
        },
        {
          "inputs": [],
          "name": "PAYMENT_AMOUNT",
          "outputs": [
            {
              "internalType": "uint256",
              "name": "",
              "type": "uint256"
            }
          ],
          "stateMutability": "view",
          "type": "function"
        },
        {
          "inputs": [],
          "name": "RECIPIENT",
          "outputs": [
            {
              "internalType": "address payable",
              "name": "",
              "type": "address"
            }
          ],
          "stateMutability": "view",
          "type": "function"
        },
        {
          "inputs": [
            {
              "internalType": "address[]",
              "name": "addresses",
              "type": "address[]"
            }
          ],
          "name": "addToFreeMap",
          "outputs": [],
          "stateMutability": "nonpayable",
          "type": "function"
        },
        {
          "inputs": [
            {
              "internalType": "address",
              "name": "",
              "type": "address"
            }
          ],
          "name": "freemap",
          "outputs": [
            {
              "internalType": "bool",
              "name": "",
              "type": "bool"
            }
          ],
          "stateMutability": "view",
          "type": "function"
        },
        {
          "inputs": [
            {
              "internalType": "address payable",
              "name": "to",
              "type": "address"
            },
            {
              "internalType": "uint96",
              "name": "subID",
              "type": "uint96"
            },
            {
              "internalType": "bytes",
              "name": "data",
              "type": "bytes"
            },
            {
              "internalType": "address payable",
              "name": "extraNativeTokenRecipient",
              "type": "address"
            },
            {
              "internalType": "uint256",
              "name": "extraNativeTokenAmount",
              "type": "uint256"
            },
            {
              "internalType": "address",
              "name": "referrer",
              "type": "address"
            }
          ],
          "name": "purchase",
          "outputs": [],
          "stateMutability": "payable",
          "type": "function"
        },
        {
          "inputs": [
            {
              "internalType": "address[]",
              "name": "addresses",
              "type": "address[]"
            }
          ],
          "name": "removeFromFreeMap",
          "outputs": [],
          "stateMutability": "nonpayable",
          "type": "function"
        }
      ],
      "address": "0xc171d58Ee94aCF468913886F748854C9832b2541",
      "startBlock": 30136242
    },
    "AvatarsSale_Proxy": {
      "abi": [
        {
          "inputs": [
            {
              "internalType": "address",
              "name": "implementationAddress",
              "type": "address"
            },
            {
              "internalType": "address",
              "name": "ownerAddress",
              "type": "address"
            },
            {
              "internalType": "bytes",
              "name": "data",
              "type": "bytes"
            }
          ],
          "stateMutability": "payable",
          "type": "constructor"
        },
        {
          "anonymous": false,
          "inputs": [
            {
              "indexed": true,
              "internalType": "address",
              "name": "previousOwner",
              "type": "address"
            },
            {
              "indexed": true,
              "internalType": "address",
              "name": "newOwner",
              "type": "address"
            }
          ],
          "name": "OwnershipTransferred",
          "type": "event"
        },
        {
          "anonymous": false,
          "inputs": [
            {
              "indexed": true,
              "internalType": "address",
              "name": "previousImplementation",
              "type": "address"
            },
            {
              "indexed": true,
              "internalType": "address",
              "name": "newImplementation",
              "type": "address"
            }
          ],
          "name": "ProxyImplementationUpdated",
          "type": "event"
        },
        {
          "stateMutability": "payable",
          "type": "fallback"
        },
        {
          "inputs": [],
          "name": "owner",
          "outputs": [
            {
              "internalType": "address",
              "name": "",
              "type": "address"
            }
          ],
          "stateMutability": "view",
          "type": "function"
        },
        {
          "inputs": [
            {
              "internalType": "bytes4",
              "name": "id",
              "type": "bytes4"
            }
          ],
          "name": "supportsInterface",
          "outputs": [
            {
              "internalType": "bool",
              "name": "",
              "type": "bool"
            }
          ],
          "stateMutability": "view",
          "type": "function"
        },
        {
          "inputs": [
            {
              "internalType": "address",
              "name": "newOwner",
              "type": "address"
            }
          ],
          "name": "transferOwnership",
          "outputs": [],
          "stateMutability": "nonpayable",
          "type": "function"
        },
        {
          "inputs": [
            {
              "internalType": "address",
              "name": "newImplementation",
              "type": "address"
            }
          ],
          "name": "upgradeTo",
          "outputs": [],
          "stateMutability": "nonpayable",
          "type": "function"
        },
        {
          "inputs": [
            {
              "internalType": "address",
              "name": "newImplementation",
              "type": "address"
            },
            {
              "internalType": "bytes",
              "name": "data",
              "type": "bytes"
            }
          ],
          "name": "upgradeToAndCall",
          "outputs": [],
          "stateMutability": "payable",
          "type": "function"
        },
        {
          "stateMutability": "payable",
          "type": "receive"
        }
      ],
      "address": "0x3316bad0628afa81b5657e109e71d7831b036ec0",
      "startBlock": 30136244
    },
    "Game": {
      "abi": [
        {
          "inputs": [
            {
              "internalType": "uint256",
              "name": "avatarID",
              "type": "uint256"
            }
          ],
          "name": "AvatarAlreadyInGame",
          "type": "error"
        },
        {
          "inputs": [
            {
              "internalType": "uint256",
              "name": "avatarID",
              "type": "uint256"
            }
          ],
          "name": "AvatarIsDead",
          "type": "error"
        },
        {
          "inputs": [
            {
              "internalType": "uint256",
              "name": "avatarID",
              "type": "uint256"
            }
          ],
          "name": "AvatarNotAvailable",
          "type": "error"
        },
        {
          "inputs": [
            {
              "internalType": "uint256",
              "name": "avatarID",
              "type": "uint256"
            }
          ],
          "name": "AvatarNotInGame",
          "type": "error"
        },
        {
          "inputs": [
            {
              "internalType": "uint256",
              "name": "avatarID",
              "type": "uint256"
            }
          ],
          "name": "AvatarNotReady",
          "type": "error"
        },
        {
          "inputs": [
            {
              "internalType": "uint256",
              "name": "avatarID",
              "type": "uint256"
            }
          ],
          "name": "AvatarStillInGame",
          "type": "error"
        },
        {
          "inputs": [
            {
              "internalType": "uint64",
              "name": "epoch",
              "type": "uint64"
            }
          ],
          "name": "CanStillReveal",
          "type": "error"
        },
        {
          "inputs": [],
          "name": "CommitmentHashNotMatching",
          "type": "error"
        },
        {
          "inputs": [],
          "name": "GameNotStarted",
          "type": "error"
        },
        {
          "inputs": [],
          "name": "ImpossibleConfiguration",
          "type": "error"
        },
        {
          "inputs": [
            {
              "internalType": "uint64",
              "name": "epoch",
              "type": "uint64"
            }
          ],
          "name": "InCommitmentPhase",
          "type": "error"
        },
        {
          "inputs": [
            {
              "internalType": "uint64",
              "name": "epoch",
              "type": "uint64"
            }
          ],
          "name": "InRevealPhase",
          "type": "error"
        },
        {
          "inputs": [],
          "name": "InvalidData",
          "type": "error"
        },
        {
          "inputs": [
            {
              "internalType": "uint64",
              "name": "expectedEpoch",
              "type": "uint64"
            },
            {
              "internalType": "uint64",
              "name": "epochGiven",
              "type": "uint64"
            }
          ],
          "name": "InvalidEpoch",
          "type": "error"
        },
        {
          "inputs": [],
          "name": "NoCommitmentToCancel",
          "type": "error"
        },
        {
          "inputs": [
            {
              "internalType": "address",
              "name": "account",
              "type": "address"
            }
          ],
          "name": "NotAuthorizedController",
          "type": "error"
        },
        {
          "inputs": [
            {
              "internalType": "address",
              "name": "account",
              "type": "address"
            }
          ],
          "name": "NotAuthorizedOwner",
          "type": "error"
        },
        {
          "inputs": [],
          "name": "NothingToReveal",
          "type": "error"
        },
        {
          "inputs": [],
          "name": "OnlyAvatarsAreAccepted",
          "type": "error"
        },
        {
          "inputs": [],
          "name": "PreviousCommitmentNotRevealed",
          "type": "error"
        },
        {
          "inputs": [
            {
              "internalType": "uint64",
              "name": "position",
              "type": "uint64"
            }
          ],
          "name": "UnableToExitFromThisPosition",
          "type": "error"
        },
        {
          "anonymous": false,
          "inputs": [
            {
              "indexed": true,
              "internalType": "uint256",
              "name": "avatarID",
              "type": "uint256"
            },
            {
              "indexed": true,
              "internalType": "address",
              "name": "owner",
              "type": "address"
            },
            {
              "indexed": false,
              "internalType": "address",
              "name": "controller",
              "type": "address"
            }
          ],
          "name": "AvatarDeposited",
          "type": "event"
        },
        {
          "anonymous": false,
          "inputs": [
            {
              "indexed": true,
              "internalType": "uint256",
              "name": "avatarID",
              "type": "uint256"
            }
          ],
          "name": "AvatarWithdrawn",
          "type": "event"
        },
        {
          "anonymous": false,
          "inputs": [
            {
              "indexed": true,
              "internalType": "uint256",
              "name": "avatarID",
              "type": "uint256"
            },
            {
              "indexed": true,
              "internalType": "uint64",
              "name": "epoch",
              "type": "uint64"
            }
          ],
          "name": "CommitmentCancelled",
          "type": "event"
        },
        {
          "anonymous": false,
          "inputs": [
            {
              "indexed": true,
              "internalType": "uint256",
              "name": "avatarID",
              "type": "uint256"
            },
            {
              "indexed": true,
              "internalType": "uint64",
              "name": "epoch",
              "type": "uint64"
            },
            {
              "indexed": false,
              "internalType": "bytes24",
              "name": "commitmentHash",
              "type": "bytes24"
            }
          ],
          "name": "CommitmentMade",
          "type": "event"
        },
        {
          "anonymous": false,
          "inputs": [
            {
              "indexed": true,
              "internalType": "uint256",
              "name": "avatarID",
              "type": "uint256"
            },
            {
              "indexed": true,
              "internalType": "uint64",
              "name": "epoch",
              "type": "uint64"
            },
            {
              "indexed": true,
              "internalType": "uint64",
              "name": "zone",
              "type": "uint64"
            },
            {
              "indexed": false,
              "internalType": "bytes24",
              "name": "commitmentHash",
              "type": "bytes24"
            },
            {
              "components": [
                {
                  "internalType": "enum UsingGameTypes.ActionType",
                  "name": "actionType",
                  "type": "uint8"
                },
                {
                  "internalType": "uint128",
                  "name": "data",
                  "type": "uint128"
                }
              ],
              "indexed": false,
              "internalType": "struct UsingGameTypes.Action[]",
              "name": "actions",
              "type": "tuple[]"
            }
          ],
          "name": "CommitmentRevealed",
          "type": "event"
        },
        {
          "anonymous": false,
          "inputs": [
            {
              "indexed": true,
              "internalType": "uint256",
              "name": "avatarID",
              "type": "uint256"
            },
            {
              "indexed": true,
              "internalType": "uint64",
              "name": "epoch",
              "type": "uint64"
            }
          ],
          "name": "CommitmentVoid",
          "type": "event"
        },
        {
          "anonymous": false,
          "inputs": [
            {
              "indexed": true,
              "internalType": "uint256",
              "name": "avatarID",
              "type": "uint256"
            },
            {
              "indexed": true,
              "internalType": "uint64",
              "name": "epoch",
              "type": "uint64"
            },
            {
              "indexed": true,
              "internalType": "uint64",
              "name": "zone",
              "type": "uint64"
            },
            {
              "indexed": false,
              "internalType": "uint64",
              "name": "newPosition",
              "type": "uint64"
            }
          ],
          "name": "EnteredTheGame",
          "type": "event"
        },
        {
          "anonymous": false,
          "inputs": [
            {
              "indexed": false,
              "internalType": "bytes4",
              "name": "selector",
              "type": "bytes4"
            },
            {
              "indexed": false,
              "internalType": "bytes",
              "name": "data",
              "type": "bytes"
            }
          ],
          "name": "Error",
          "type": "event"
        },
        {
          "anonymous": false,
          "inputs": [
            {
              "indexed": true,
              "internalType": "uint256",
              "name": "avatarID",
              "type": "uint256"
            },
            {
              "indexed": true,
              "internalType": "uint64",
              "name": "epoch",
              "type": "uint64"
            },
            {
              "indexed": true,
              "internalType": "uint64",
              "name": "zoneWhenLeaving",
              "type": "uint64"
            },
            {
              "indexed": false,
              "internalType": "uint64",
              "name": "positionWhenLeaving",
              "type": "uint64"
            }
          ],
          "name": "LeftTheGame",
          "type": "event"
        },
        {
          "anonymous": false,
          "inputs": [
            {
              "indexed": true,
              "internalType": "uint256",
              "name": "avatarID",
              "type": "uint256"
            },
            {
              "indexed": false,
              "internalType": "uint64",
              "name": "epoch",
              "type": "uint64"
            },
            {
              "indexed": false,
              "internalType": "bytes24",
              "name": "commitmentHash",
              "type": "bytes24"
            }
          ],
          "name": "PreviousCommitmentNotRevealedEvent",
          "type": "event"
        },
        {
          "inputs": [
            {
              "internalType": "uint256",
              "name": "avatarID",
              "type": "uint256"
            }
          ],
          "name": "getAvatar",
          "outputs": [
            {
              "components": [
                {
                  "internalType": "address",
                  "name": "owner",
                  "type": "address"
                },
                {
                  "internalType": "uint256",
                  "name": "avatarID",
                  "type": "uint256"
                },
                {
                  "internalType": "bool",
                  "name": "inGame",
                  "type": "bool"
                },
                {
                  "internalType": "uint64",
                  "name": "position",
                  "type": "uint64"
                },
                {
                  "internalType": "uint64",
                  "name": "lastEpoch",
                  "type": "uint64"
                },
                {
                  "internalType": "uint8",
                  "name": "life",
                  "type": "uint8"
                }
              ],
              "internalType": "struct UsingGameTypes.PublicAvatar",
              "name": "",
              "type": "tuple"
            }
          ],
          "stateMutability": "view",
          "type": "function"
        },
        {
          "inputs": [
            {
              "internalType": "uint64[]",
              "name": "zones",
              "type": "uint64[]"
            },
            {
              "internalType": "uint64",
              "name": "fromIndex",
              "type": "uint64"
            },
            {
              "internalType": "uint64",
              "name": "limit",
              "type": "uint64"
            }
          ],
          "name": "getAvatarsInMultipleZones",
          "outputs": [
            {
              "components": [
                {
                  "internalType": "address",
                  "name": "owner",
                  "type": "address"
                },
                {
                  "internalType": "uint256",
                  "name": "avatarID",
                  "type": "uint256"
                },
                {
                  "internalType": "bool",
                  "name": "inGame",
                  "type": "bool"
                },
                {
                  "internalType": "uint64",
                  "name": "position",
                  "type": "uint64"
                },
                {
                  "internalType": "uint64",
                  "name": "lastEpoch",
                  "type": "uint64"
                },
                {
                  "internalType": "uint8",
                  "name": "life",
                  "type": "uint8"
                }
              ],
              "internalType": "struct UsingGameTypes.PublicAvatar[]",
              "name": "avatars",
              "type": "tuple[]"
            },
            {
              "internalType": "bool",
              "name": "more",
              "type": "bool"
            },
            {
              "internalType": "uint64",
              "name": "epoch",
              "type": "uint64"
            }
          ],
          "stateMutability": "view",
          "type": "function"
        },
        {
          "inputs": [
            {
              "internalType": "uint64",
              "name": "zone",
              "type": "uint64"
            },
            {
              "internalType": "uint64",
              "name": "fromIndex",
              "type": "uint64"
            },
            {
              "internalType": "uint64",
              "name": "limit",
              "type": "uint64"
            }
          ],
          "name": "getAvatarsInZone",
          "outputs": [
            {
              "components": [
                {
                  "internalType": "address",
                  "name": "owner",
                  "type": "address"
                },
                {
                  "internalType": "uint256",
                  "name": "avatarID",
                  "type": "uint256"
                },
                {
                  "internalType": "bool",
                  "name": "inGame",
                  "type": "bool"
                },
                {
                  "internalType": "uint64",
                  "name": "position",
                  "type": "uint64"
                },
                {
                  "internalType": "uint64",
                  "name": "lastEpoch",
                  "type": "uint64"
                },
                {
                  "internalType": "uint8",
                  "name": "life",
                  "type": "uint8"
                }
              ],
              "internalType": "struct UsingGameTypes.PublicAvatar[]",
              "name": "avatars",
              "type": "tuple[]"
            },
            {
              "internalType": "bool",
              "name": "more",
              "type": "bool"
            },
            {
              "internalType": "uint64",
              "name": "epoch",
              "type": "uint64"
            }
          ],
          "stateMutability": "view",
          "type": "function"
        },
        {
          "inputs": [
            {
              "internalType": "uint256",
              "name": "avatarID",
              "type": "uint256"
            }
          ],
          "name": "getCommitment",
          "outputs": [
            {
              "components": [
                {
                  "internalType": "bytes24",
                  "name": "hash",
                  "type": "bytes24"
                },
                {
                  "internalType": "uint64",
                  "name": "epoch",
                  "type": "uint64"
                }
              ],
              "internalType": "struct UsingGameTypes.Commitment",
              "name": "commitment",
              "type": "tuple"
            }
          ],
          "stateMutability": "view",
          "type": "function"
        },
        {
          "inputs": [],
          "name": "getConfig",
          "outputs": [
            {
              "components": [
                {
                  "internalType": "uint256",
                  "name": "startTime",
                  "type": "uint256"
                },
                {
                  "internalType": "uint256",
                  "name": "commitPhaseDuration",
                  "type": "uint256"
                },
                {
                  "internalType": "uint256",
                  "name": "revealPhaseDuration",
                  "type": "uint256"
                },
                {
                  "internalType": "contract ITime",
                  "name": "time",
                  "type": "address"
                },
                {
                  "internalType": "contract IERC721",
                  "name": "avatars",
                  "type": "address"
                },
                {
                  "internalType": "uint256",
                  "name": "numMoves",
                  "type": "uint256"
                }
              ],
              "internalType": "struct UsingGameTypes.Config",
              "name": "config",
              "type": "tuple"
            }
          ],
          "stateMutability": "view",
          "type": "function"
        },
        {
          "inputs": [],
          "name": "getEpoch",
          "outputs": [
            {
              "internalType": "uint64",
              "name": "epoch",
              "type": "uint64"
            },
            {
              "internalType": "bool",
              "name": "commiting",
              "type": "bool"
            }
          ],
          "stateMutability": "view",
          "type": "function"
        },
        {
          "inputs": [
            {
              "internalType": "address",
              "name": "owner",
              "type": "address"
            },
            {
              "internalType": "uint256",
              "name": "startIndex",
              "type": "uint256"
            },
            {
              "internalType": "uint256",
              "name": "limit",
              "type": "uint256"
            }
          ],
          "name": "avatarsPerOwner",
          "outputs": [
            {
              "components": [
                {
                  "internalType": "address",
                  "name": "owner",
                  "type": "address"
                },
                {
                  "internalType": "uint256",
                  "name": "avatarID",
                  "type": "uint256"
                },
                {
                  "internalType": "bool",
                  "name": "inGame",
                  "type": "bool"
                },
                {
                  "internalType": "uint64",
                  "name": "position",
                  "type": "uint64"
                },
                {
                  "internalType": "uint64",
                  "name": "lastEpoch",
                  "type": "uint64"
                },
                {
                  "internalType": "uint8",
                  "name": "life",
                  "type": "uint8"
                }
              ],
              "internalType": "struct UsingGameTypes.PublicAvatar[]",
              "name": "avatarIDs",
              "type": "tuple[]"
            },
            {
              "internalType": "bool",
              "name": "more",
              "type": "bool"
            }
          ],
          "stateMutability": "view",
          "type": "function"
        },
        {
          "inputs": [
            {
              "internalType": "uint256",
              "name": "avatarID",
              "type": "uint256"
            },
            {
              "internalType": "address",
              "name": "controller",
              "type": "address"
            },
            {
              "internalType": "address payable",
              "name": "payee",
              "type": "address"
            }
          ],
          "name": "deposit",
          "outputs": [],
          "stateMutability": "payable",
          "type": "function"
        },
        {
          "inputs": [
            {
              "internalType": "address",
              "name": "",
              "type": "address"
            },
            {
              "internalType": "address",
              "name": "",
              "type": "address"
            },
            {
              "internalType": "uint256",
              "name": "tokenID",
              "type": "uint256"
            },
            {
              "internalType": "bytes",
              "name": "data",
              "type": "bytes"
            }
          ],
          "name": "onERC721Received",
          "outputs": [
            {
              "internalType": "bytes4",
              "name": "",
              "type": "bytes4"
            }
          ],
          "stateMutability": "nonpayable",
          "type": "function"
        },
        {
          "inputs": [
            {
              "internalType": "uint256",
              "name": "avatarID",
              "type": "uint256"
            },
            {
              "internalType": "address",
              "name": "to",
              "type": "address"
            }
          ],
          "name": "withdraw",
          "outputs": [],
          "stateMutability": "nonpayable",
          "type": "function"
        },
        {
          "inputs": [
            {
              "internalType": "uint256",
              "name": "avatarID",
              "type": "uint256"
            }
          ],
          "name": "cancelCommit",
          "outputs": [],
          "stateMutability": "nonpayable",
          "type": "function"
        },
        {
          "inputs": [
            {
              "internalType": "uint256",
              "name": "avatarID",
              "type": "uint256"
            },
            {
              "internalType": "bytes24",
              "name": "commitmentHash",
              "type": "bytes24"
            },
            {
              "internalType": "address payable",
              "name": "payee",
              "type": "address"
            }
          ],
          "name": "commit",
          "outputs": [],
          "stateMutability": "payable",
          "type": "function"
        },
        {
          "inputs": [
            {
              "internalType": "uint256",
              "name": "value",
              "type": "uint256"
            },
            {
              "internalType": "uint256",
              "name": "length",
              "type": "uint256"
            }
          ],
          "name": "StringsInsufficientHexLength",
          "type": "error"
        },
        {
          "inputs": [
            {
              "internalType": "uint256",
              "name": "avatarID",
              "type": "uint256"
            }
          ],
          "name": "acknowledgeMissedReveal",
          "outputs": [],
          "stateMutability": "nonpayable",
          "type": "function"
        },
        {
          "inputs": [
            {
              "internalType": "uint256",
              "name": "avatarID",
              "type": "uint256"
            },
            {
              "components": [
                {
                  "internalType": "enum UsingGameTypes.ActionType",
                  "name": "actionType",
                  "type": "uint8"
                },
                {
                  "internalType": "uint128",
                  "name": "data",
                  "type": "uint128"
                }
              ],
              "internalType": "struct UsingGameTypes.Action[]",
              "name": "actions",
              "type": "tuple[]"
            },
            {
              "internalType": "bytes32",
              "name": "secret",
              "type": "bytes32"
            },
            {
              "internalType": "address payable",
              "name": "payee",
              "type": "address"
            }
          ],
          "name": "reveal",
          "outputs": [],
          "stateMutability": "payable",
          "type": "function"
        }
      ],
      "address": "0x7b27cc76ac4cd4e142b1bacee996941e12e95529",
      "linkedData": {
        "startTime": "0",
        "commitPhaseDuration": "32",
        "revealPhaseDuration": "5",
        "time": "0x0000000000000000000000000000000000000000",
        "avatars": "0x3368e40595904944e5791002cfef39bc411d9f12",
        "numMoves": "10"
      },
      "startBlock": 30176502
    },
    "Game_Implementation": {
      "abi": [
        {
          "inputs": [
            {
              "internalType": "uint256",
              "name": "avatarID",
              "type": "uint256"
            }
          ],
          "name": "AvatarAlreadyInGame",
          "type": "error"
        },
        {
          "inputs": [
            {
              "internalType": "uint256",
              "name": "avatarID",
              "type": "uint256"
            }
          ],
          "name": "AvatarIsDead",
          "type": "error"
        },
        {
          "inputs": [
            {
              "internalType": "uint256",
              "name": "avatarID",
              "type": "uint256"
            }
          ],
          "name": "AvatarNotAvailable",
          "type": "error"
        },
        {
          "inputs": [
            {
              "internalType": "uint256",
              "name": "avatarID",
              "type": "uint256"
            }
          ],
          "name": "AvatarNotInGame",
          "type": "error"
        },
        {
          "inputs": [
            {
              "internalType": "uint256",
              "name": "avatarID",
              "type": "uint256"
            }
          ],
          "name": "AvatarNotReady",
          "type": "error"
        },
        {
          "inputs": [
            {
              "internalType": "uint256",
              "name": "avatarID",
              "type": "uint256"
            }
          ],
          "name": "AvatarStillInGame",
          "type": "error"
        },
        {
          "inputs": [
            {
              "internalType": "uint64",
              "name": "epoch",
              "type": "uint64"
            }
          ],
          "name": "CanStillReveal",
          "type": "error"
        },
        {
          "inputs": [],
          "name": "CommitmentHashNotMatching",
          "type": "error"
        },
        {
          "inputs": [],
          "name": "GameNotStarted",
          "type": "error"
        },
        {
          "inputs": [],
          "name": "ImpossibleConfiguration",
          "type": "error"
        },
        {
          "inputs": [
            {
              "internalType": "uint64",
              "name": "epoch",
              "type": "uint64"
            }
          ],
          "name": "InCommitmentPhase",
          "type": "error"
        },
        {
          "inputs": [
            {
              "internalType": "uint64",
              "name": "epoch",
              "type": "uint64"
            }
          ],
          "name": "InRevealPhase",
          "type": "error"
        },
        {
          "inputs": [],
          "name": "InvalidData",
          "type": "error"
        },
        {
          "inputs": [
            {
              "internalType": "uint64",
              "name": "expectedEpoch",
              "type": "uint64"
            },
            {
              "internalType": "uint64",
              "name": "epochGiven",
              "type": "uint64"
            }
          ],
          "name": "InvalidEpoch",
          "type": "error"
        },
        {
          "inputs": [],
          "name": "NoCommitmentToCancel",
          "type": "error"
        },
        {
          "inputs": [
            {
              "internalType": "address",
              "name": "account",
              "type": "address"
            }
          ],
          "name": "NotAuthorizedController",
          "type": "error"
        },
        {
          "inputs": [
            {
              "internalType": "address",
              "name": "account",
              "type": "address"
            }
          ],
          "name": "NotAuthorizedOwner",
          "type": "error"
        },
        {
          "inputs": [],
          "name": "NothingToReveal",
          "type": "error"
        },
        {
          "inputs": [],
          "name": "OnlyAvatarsAreAccepted",
          "type": "error"
        },
        {
          "inputs": [],
          "name": "PreviousCommitmentNotRevealed",
          "type": "error"
        },
        {
          "inputs": [
            {
              "internalType": "uint64",
              "name": "position",
              "type": "uint64"
            }
          ],
          "name": "UnableToExitFromThisPosition",
          "type": "error"
        },
        {
          "anonymous": false,
          "inputs": [
            {
              "indexed": true,
              "internalType": "uint256",
              "name": "avatarID",
              "type": "uint256"
            },
            {
              "indexed": true,
              "internalType": "address",
              "name": "owner",
              "type": "address"
            },
            {
              "indexed": false,
              "internalType": "address",
              "name": "controller",
              "type": "address"
            }
          ],
          "name": "AvatarDeposited",
          "type": "event"
        },
        {
          "anonymous": false,
          "inputs": [
            {
              "indexed": true,
              "internalType": "uint256",
              "name": "avatarID",
              "type": "uint256"
            }
          ],
          "name": "AvatarWithdrawn",
          "type": "event"
        },
        {
          "anonymous": false,
          "inputs": [
            {
              "indexed": true,
              "internalType": "uint256",
              "name": "avatarID",
              "type": "uint256"
            },
            {
              "indexed": true,
              "internalType": "uint64",
              "name": "epoch",
              "type": "uint64"
            }
          ],
          "name": "CommitmentCancelled",
          "type": "event"
        },
        {
          "anonymous": false,
          "inputs": [
            {
              "indexed": true,
              "internalType": "uint256",
              "name": "avatarID",
              "type": "uint256"
            },
            {
              "indexed": true,
              "internalType": "uint64",
              "name": "epoch",
              "type": "uint64"
            },
            {
              "indexed": false,
              "internalType": "bytes24",
              "name": "commitmentHash",
              "type": "bytes24"
            }
          ],
          "name": "CommitmentMade",
          "type": "event"
        },
        {
          "anonymous": false,
          "inputs": [
            {
              "indexed": true,
              "internalType": "uint256",
              "name": "avatarID",
              "type": "uint256"
            },
            {
              "indexed": true,
              "internalType": "uint64",
              "name": "epoch",
              "type": "uint64"
            },
            {
              "indexed": true,
              "internalType": "uint64",
              "name": "zone",
              "type": "uint64"
            },
            {
              "indexed": false,
              "internalType": "bytes24",
              "name": "commitmentHash",
              "type": "bytes24"
            },
            {
              "components": [
                {
                  "internalType": "enum UsingGameTypes.ActionType",
                  "name": "actionType",
                  "type": "uint8"
                },
                {
                  "internalType": "uint128",
                  "name": "data",
                  "type": "uint128"
                }
              ],
              "indexed": false,
              "internalType": "struct UsingGameTypes.Action[]",
              "name": "actions",
              "type": "tuple[]"
            }
          ],
          "name": "CommitmentRevealed",
          "type": "event"
        },
        {
          "anonymous": false,
          "inputs": [
            {
              "indexed": true,
              "internalType": "uint256",
              "name": "avatarID",
              "type": "uint256"
            },
            {
              "indexed": true,
              "internalType": "uint64",
              "name": "epoch",
              "type": "uint64"
            }
          ],
          "name": "CommitmentVoid",
          "type": "event"
        },
        {
          "anonymous": false,
          "inputs": [
            {
              "indexed": true,
              "internalType": "uint256",
              "name": "avatarID",
              "type": "uint256"
            },
            {
              "indexed": true,
              "internalType": "uint64",
              "name": "epoch",
              "type": "uint64"
            },
            {
              "indexed": true,
              "internalType": "uint64",
              "name": "zone",
              "type": "uint64"
            },
            {
              "indexed": false,
              "internalType": "uint64",
              "name": "newPosition",
              "type": "uint64"
            }
          ],
          "name": "EnteredTheGame",
          "type": "event"
        },
        {
          "anonymous": false,
          "inputs": [
            {
              "indexed": false,
              "internalType": "bytes4",
              "name": "selector",
              "type": "bytes4"
            },
            {
              "indexed": false,
              "internalType": "bytes",
              "name": "data",
              "type": "bytes"
            }
          ],
          "name": "Error",
          "type": "event"
        },
        {
          "anonymous": false,
          "inputs": [
            {
              "indexed": true,
              "internalType": "uint256",
              "name": "avatarID",
              "type": "uint256"
            },
            {
              "indexed": true,
              "internalType": "uint64",
              "name": "epoch",
              "type": "uint64"
            },
            {
              "indexed": true,
              "internalType": "uint64",
              "name": "zoneWhenLeaving",
              "type": "uint64"
            },
            {
              "indexed": false,
              "internalType": "uint64",
              "name": "positionWhenLeaving",
              "type": "uint64"
            }
          ],
          "name": "LeftTheGame",
          "type": "event"
        },
        {
          "anonymous": false,
          "inputs": [
            {
              "indexed": true,
              "internalType": "uint256",
              "name": "avatarID",
              "type": "uint256"
            },
            {
              "indexed": false,
              "internalType": "uint64",
              "name": "epoch",
              "type": "uint64"
            },
            {
              "indexed": false,
              "internalType": "bytes24",
              "name": "commitmentHash",
              "type": "bytes24"
            }
          ],
          "name": "PreviousCommitmentNotRevealedEvent",
          "type": "event"
        },
        {
          "inputs": [
            {
              "internalType": "uint256",
              "name": "avatarID",
              "type": "uint256"
            }
          ],
          "name": "getAvatar",
          "outputs": [
            {
              "components": [
                {
                  "internalType": "address",
                  "name": "owner",
                  "type": "address"
                },
                {
                  "internalType": "uint256",
                  "name": "avatarID",
                  "type": "uint256"
                },
                {
                  "internalType": "bool",
                  "name": "inGame",
                  "type": "bool"
                },
                {
                  "internalType": "uint64",
                  "name": "position",
                  "type": "uint64"
                },
                {
                  "internalType": "uint64",
                  "name": "lastEpoch",
                  "type": "uint64"
                },
                {
                  "internalType": "uint8",
                  "name": "life",
                  "type": "uint8"
                }
              ],
              "internalType": "struct UsingGameTypes.PublicAvatar",
              "name": "",
              "type": "tuple"
            }
          ],
          "stateMutability": "view",
          "type": "function"
        },
        {
          "inputs": [
            {
              "internalType": "uint64[]",
              "name": "zones",
              "type": "uint64[]"
            },
            {
              "internalType": "uint64",
              "name": "fromIndex",
              "type": "uint64"
            },
            {
              "internalType": "uint64",
              "name": "limit",
              "type": "uint64"
            }
          ],
          "name": "getAvatarsInMultipleZones",
          "outputs": [
            {
              "components": [
                {
                  "internalType": "address",
                  "name": "owner",
                  "type": "address"
                },
                {
                  "internalType": "uint256",
                  "name": "avatarID",
                  "type": "uint256"
                },
                {
                  "internalType": "bool",
                  "name": "inGame",
                  "type": "bool"
                },
                {
                  "internalType": "uint64",
                  "name": "position",
                  "type": "uint64"
                },
                {
                  "internalType": "uint64",
                  "name": "lastEpoch",
                  "type": "uint64"
                },
                {
                  "internalType": "uint8",
                  "name": "life",
                  "type": "uint8"
                }
              ],
              "internalType": "struct UsingGameTypes.PublicAvatar[]",
              "name": "avatars",
              "type": "tuple[]"
            },
            {
              "internalType": "bool",
              "name": "more",
              "type": "bool"
            },
            {
              "internalType": "uint64",
              "name": "epoch",
              "type": "uint64"
            }
          ],
          "stateMutability": "view",
          "type": "function"
        },
        {
          "inputs": [
            {
              "internalType": "uint64",
              "name": "zone",
              "type": "uint64"
            },
            {
              "internalType": "uint64",
              "name": "fromIndex",
              "type": "uint64"
            },
            {
              "internalType": "uint64",
              "name": "limit",
              "type": "uint64"
            }
          ],
          "name": "getAvatarsInZone",
          "outputs": [
            {
              "components": [
                {
                  "internalType": "address",
                  "name": "owner",
                  "type": "address"
                },
                {
                  "internalType": "uint256",
                  "name": "avatarID",
                  "type": "uint256"
                },
                {
                  "internalType": "bool",
                  "name": "inGame",
                  "type": "bool"
                },
                {
                  "internalType": "uint64",
                  "name": "position",
                  "type": "uint64"
                },
                {
                  "internalType": "uint64",
                  "name": "lastEpoch",
                  "type": "uint64"
                },
                {
                  "internalType": "uint8",
                  "name": "life",
                  "type": "uint8"
                }
              ],
              "internalType": "struct UsingGameTypes.PublicAvatar[]",
              "name": "avatars",
              "type": "tuple[]"
            },
            {
              "internalType": "bool",
              "name": "more",
              "type": "bool"
            },
            {
              "internalType": "uint64",
              "name": "epoch",
              "type": "uint64"
            }
          ],
          "stateMutability": "view",
          "type": "function"
        },
        {
          "inputs": [
            {
              "internalType": "uint256",
              "name": "avatarID",
              "type": "uint256"
            }
          ],
          "name": "getCommitment",
          "outputs": [
            {
              "components": [
                {
                  "internalType": "bytes24",
                  "name": "hash",
                  "type": "bytes24"
                },
                {
                  "internalType": "uint64",
                  "name": "epoch",
                  "type": "uint64"
                }
              ],
              "internalType": "struct UsingGameTypes.Commitment",
              "name": "commitment",
              "type": "tuple"
            }
          ],
          "stateMutability": "view",
          "type": "function"
        },
        {
          "inputs": [],
          "name": "getConfig",
          "outputs": [
            {
              "components": [
                {
                  "internalType": "uint256",
                  "name": "startTime",
                  "type": "uint256"
                },
                {
                  "internalType": "uint256",
                  "name": "commitPhaseDuration",
                  "type": "uint256"
                },
                {
                  "internalType": "uint256",
                  "name": "revealPhaseDuration",
                  "type": "uint256"
                },
                {
                  "internalType": "contract ITime",
                  "name": "time",
                  "type": "address"
                },
                {
                  "internalType": "contract IERC721",
                  "name": "avatars",
                  "type": "address"
                },
                {
                  "internalType": "uint256",
                  "name": "numMoves",
                  "type": "uint256"
                }
              ],
              "internalType": "struct UsingGameTypes.Config",
              "name": "config",
              "type": "tuple"
            }
          ],
          "stateMutability": "view",
          "type": "function"
        },
        {
          "inputs": [],
          "name": "getEpoch",
          "outputs": [
            {
              "internalType": "uint64",
              "name": "epoch",
              "type": "uint64"
            },
            {
              "internalType": "bool",
              "name": "commiting",
              "type": "bool"
            }
          ],
          "stateMutability": "view",
          "type": "function"
        },
        {
          "inputs": [
            {
              "internalType": "address",
              "name": "owner",
              "type": "address"
            },
            {
              "internalType": "uint256",
              "name": "startIndex",
              "type": "uint256"
            },
            {
              "internalType": "uint256",
              "name": "limit",
              "type": "uint256"
            }
          ],
          "name": "avatarsPerOwner",
          "outputs": [
            {
              "components": [
                {
                  "internalType": "address",
                  "name": "owner",
                  "type": "address"
                },
                {
                  "internalType": "uint256",
                  "name": "avatarID",
                  "type": "uint256"
                },
                {
                  "internalType": "bool",
                  "name": "inGame",
                  "type": "bool"
                },
                {
                  "internalType": "uint64",
                  "name": "position",
                  "type": "uint64"
                },
                {
                  "internalType": "uint64",
                  "name": "lastEpoch",
                  "type": "uint64"
                },
                {
                  "internalType": "uint8",
                  "name": "life",
                  "type": "uint8"
                }
              ],
              "internalType": "struct UsingGameTypes.PublicAvatar[]",
              "name": "avatarIDs",
              "type": "tuple[]"
            },
            {
              "internalType": "bool",
              "name": "more",
              "type": "bool"
            }
          ],
          "stateMutability": "view",
          "type": "function"
        },
        {
          "inputs": [
            {
              "internalType": "uint256",
              "name": "avatarID",
              "type": "uint256"
            },
            {
              "internalType": "address",
              "name": "controller",
              "type": "address"
            },
            {
              "internalType": "address payable",
              "name": "payee",
              "type": "address"
            }
          ],
          "name": "deposit",
          "outputs": [],
          "stateMutability": "payable",
          "type": "function"
        },
        {
          "inputs": [
            {
              "internalType": "address",
              "name": "",
              "type": "address"
            },
            {
              "internalType": "address",
              "name": "",
              "type": "address"
            },
            {
              "internalType": "uint256",
              "name": "tokenID",
              "type": "uint256"
            },
            {
              "internalType": "bytes",
              "name": "data",
              "type": "bytes"
            }
          ],
          "name": "onERC721Received",
          "outputs": [
            {
              "internalType": "bytes4",
              "name": "",
              "type": "bytes4"
            }
          ],
          "stateMutability": "nonpayable",
          "type": "function"
        },
        {
          "inputs": [
            {
              "internalType": "uint256",
              "name": "avatarID",
              "type": "uint256"
            },
            {
              "internalType": "address",
              "name": "to",
              "type": "address"
            }
          ],
          "name": "withdraw",
          "outputs": [],
          "stateMutability": "nonpayable",
          "type": "function"
        },
        {
          "inputs": [
            {
              "internalType": "uint256",
              "name": "avatarID",
              "type": "uint256"
            }
          ],
          "name": "cancelCommit",
          "outputs": [],
          "stateMutability": "nonpayable",
          "type": "function"
        },
        {
          "inputs": [
            {
              "internalType": "uint256",
              "name": "avatarID",
              "type": "uint256"
            },
            {
              "internalType": "bytes24",
              "name": "commitmentHash",
              "type": "bytes24"
            },
            {
              "internalType": "address payable",
              "name": "payee",
              "type": "address"
            }
          ],
          "name": "commit",
          "outputs": [],
          "stateMutability": "payable",
          "type": "function"
        },
        {
          "inputs": [
            {
              "internalType": "uint256",
              "name": "value",
              "type": "uint256"
            },
            {
              "internalType": "uint256",
              "name": "length",
              "type": "uint256"
            }
          ],
          "name": "StringsInsufficientHexLength",
          "type": "error"
        },
        {
          "inputs": [
            {
              "internalType": "uint256",
              "name": "avatarID",
              "type": "uint256"
            }
          ],
          "name": "acknowledgeMissedReveal",
          "outputs": [],
          "stateMutability": "nonpayable",
          "type": "function"
        },
        {
          "inputs": [
            {
              "internalType": "uint256",
              "name": "avatarID",
              "type": "uint256"
            },
            {
              "components": [
                {
                  "internalType": "enum UsingGameTypes.ActionType",
                  "name": "actionType",
                  "type": "uint8"
                },
                {
                  "internalType": "uint128",
                  "name": "data",
                  "type": "uint128"
                }
              ],
              "internalType": "struct UsingGameTypes.Action[]",
              "name": "actions",
              "type": "tuple[]"
            },
            {
              "internalType": "bytes32",
              "name": "secret",
              "type": "bytes32"
            },
            {
              "internalType": "address payable",
              "name": "payee",
              "type": "address"
            }
          ],
          "name": "reveal",
          "outputs": [],
          "stateMutability": "payable",
          "type": "function"
        }
      ],
      "address": "0x00466d78b4b5f9e85337f0d71bedbb5ffe33fa62",
      "startBlock": 30176502
    },
    "Game_Implementation_Router": {
      "abi": [
        {
          "inputs": [
            {
              "components": [
                {
                  "internalType": "address[]",
                  "name": "implementations",
                  "type": "address[]"
                },
                {
                  "internalType": "bytes5[]",
                  "name": "sigMap",
                  "type": "bytes5[]"
                },
                {
                  "internalType": "address",
                  "name": "fallbackImplementation",
                  "type": "address"
                }
              ],
              "internalType": "struct Router10X60.Routes",
              "name": "routes",
              "type": "tuple"
            }
          ],
          "stateMutability": "nonpayable",
          "type": "constructor"
        },
        {
          "stateMutability": "payable",
          "type": "fallback"
        }
      ],
      "address": "0x00466d78b4b5f9e85337f0d71bedbb5ffe33fa62",
      "startBlock": 30176502
    },
    "Game_Implementation_Router_Commit_Route": {
      "abi": [
        {
          "inputs": [
            {
              "components": [
                {
                  "internalType": "uint256",
                  "name": "startTime",
                  "type": "uint256"
                },
                {
                  "internalType": "uint256",
                  "name": "commitPhaseDuration",
                  "type": "uint256"
                },
                {
                  "internalType": "uint256",
                  "name": "revealPhaseDuration",
                  "type": "uint256"
                },
                {
                  "internalType": "contract ITime",
                  "name": "time",
                  "type": "address"
                },
                {
                  "internalType": "contract IERC721",
                  "name": "avatars",
                  "type": "address"
                },
                {
                  "internalType": "uint256",
                  "name": "numMoves",
                  "type": "uint256"
                }
              ],
              "internalType": "struct UsingGameTypes.Config",
              "name": "config",
              "type": "tuple"
            }
          ],
          "stateMutability": "nonpayable",
          "type": "constructor"
        },
        {
          "inputs": [
            {
              "internalType": "uint256",
              "name": "avatarID",
              "type": "uint256"
            }
          ],
          "name": "AvatarAlreadyInGame",
          "type": "error"
        },
        {
          "inputs": [
            {
              "internalType": "uint256",
              "name": "avatarID",
              "type": "uint256"
            }
          ],
          "name": "AvatarIsDead",
          "type": "error"
        },
        {
          "inputs": [
            {
              "internalType": "uint256",
              "name": "avatarID",
              "type": "uint256"
            }
          ],
          "name": "AvatarNotAvailable",
          "type": "error"
        },
        {
          "inputs": [
            {
              "internalType": "uint256",
              "name": "avatarID",
              "type": "uint256"
            }
          ],
          "name": "AvatarNotInGame",
          "type": "error"
        },
        {
          "inputs": [
            {
              "internalType": "uint256",
              "name": "avatarID",
              "type": "uint256"
            }
          ],
          "name": "AvatarNotReady",
          "type": "error"
        },
        {
          "inputs": [
            {
              "internalType": "uint256",
              "name": "avatarID",
              "type": "uint256"
            }
          ],
          "name": "AvatarStillInGame",
          "type": "error"
        },
        {
          "inputs": [
            {
              "internalType": "uint64",
              "name": "epoch",
              "type": "uint64"
            }
          ],
          "name": "CanStillReveal",
          "type": "error"
        },
        {
          "inputs": [],
          "name": "CommitmentHashNotMatching",
          "type": "error"
        },
        {
          "inputs": [],
          "name": "GameNotStarted",
          "type": "error"
        },
        {
          "inputs": [],
          "name": "ImpossibleConfiguration",
          "type": "error"
        },
        {
          "inputs": [
            {
              "internalType": "uint64",
              "name": "epoch",
              "type": "uint64"
            }
          ],
          "name": "InCommitmentPhase",
          "type": "error"
        },
        {
          "inputs": [
            {
              "internalType": "uint64",
              "name": "epoch",
              "type": "uint64"
            }
          ],
          "name": "InRevealPhase",
          "type": "error"
        },
        {
          "inputs": [],
          "name": "InvalidData",
          "type": "error"
        },
        {
          "inputs": [
            {
              "internalType": "uint64",
              "name": "expectedEpoch",
              "type": "uint64"
            },
            {
              "internalType": "uint64",
              "name": "epochGiven",
              "type": "uint64"
            }
          ],
          "name": "InvalidEpoch",
          "type": "error"
        },
        {
          "inputs": [],
          "name": "NoCommitmentToCancel",
          "type": "error"
        },
        {
          "inputs": [
            {
              "internalType": "address",
              "name": "account",
              "type": "address"
            }
          ],
          "name": "NotAuthorizedController",
          "type": "error"
        },
        {
          "inputs": [
            {
              "internalType": "address",
              "name": "account",
              "type": "address"
            }
          ],
          "name": "NotAuthorizedOwner",
          "type": "error"
        },
        {
          "inputs": [],
          "name": "NothingToReveal",
          "type": "error"
        },
        {
          "inputs": [],
          "name": "OnlyAvatarsAreAccepted",
          "type": "error"
        },
        {
          "inputs": [],
          "name": "PreviousCommitmentNotRevealed",
          "type": "error"
        },
        {
          "inputs": [
            {
              "internalType": "uint64",
              "name": "position",
              "type": "uint64"
            }
          ],
          "name": "UnableToExitFromThisPosition",
          "type": "error"
        },
        {
          "anonymous": false,
          "inputs": [
            {
              "indexed": true,
              "internalType": "uint256",
              "name": "avatarID",
              "type": "uint256"
            },
            {
              "indexed": true,
              "internalType": "address",
              "name": "owner",
              "type": "address"
            },
            {
              "indexed": false,
              "internalType": "address",
              "name": "controller",
              "type": "address"
            }
          ],
          "name": "AvatarDeposited",
          "type": "event"
        },
        {
          "anonymous": false,
          "inputs": [
            {
              "indexed": true,
              "internalType": "uint256",
              "name": "avatarID",
              "type": "uint256"
            }
          ],
          "name": "AvatarWithdrawn",
          "type": "event"
        },
        {
          "anonymous": false,
          "inputs": [
            {
              "indexed": true,
              "internalType": "uint256",
              "name": "avatarID",
              "type": "uint256"
            },
            {
              "indexed": true,
              "internalType": "uint64",
              "name": "epoch",
              "type": "uint64"
            }
          ],
          "name": "CommitmentCancelled",
          "type": "event"
        },
        {
          "anonymous": false,
          "inputs": [
            {
              "indexed": true,
              "internalType": "uint256",
              "name": "avatarID",
              "type": "uint256"
            },
            {
              "indexed": true,
              "internalType": "uint64",
              "name": "epoch",
              "type": "uint64"
            },
            {
              "indexed": false,
              "internalType": "bytes24",
              "name": "commitmentHash",
              "type": "bytes24"
            }
          ],
          "name": "CommitmentMade",
          "type": "event"
        },
        {
          "anonymous": false,
          "inputs": [
            {
              "indexed": true,
              "internalType": "uint256",
              "name": "avatarID",
              "type": "uint256"
            },
            {
              "indexed": true,
              "internalType": "uint64",
              "name": "epoch",
              "type": "uint64"
            },
            {
              "indexed": true,
              "internalType": "uint64",
              "name": "zone",
              "type": "uint64"
            },
            {
              "indexed": false,
              "internalType": "bytes24",
              "name": "commitmentHash",
              "type": "bytes24"
            },
            {
              "components": [
                {
                  "internalType": "enum UsingGameTypes.ActionType",
                  "name": "actionType",
                  "type": "uint8"
                },
                {
                  "internalType": "uint128",
                  "name": "data",
                  "type": "uint128"
                }
              ],
              "indexed": false,
              "internalType": "struct UsingGameTypes.Action[]",
              "name": "actions",
              "type": "tuple[]"
            }
          ],
          "name": "CommitmentRevealed",
          "type": "event"
        },
        {
          "anonymous": false,
          "inputs": [
            {
              "indexed": true,
              "internalType": "uint256",
              "name": "avatarID",
              "type": "uint256"
            },
            {
              "indexed": true,
              "internalType": "uint64",
              "name": "epoch",
              "type": "uint64"
            }
          ],
          "name": "CommitmentVoid",
          "type": "event"
        },
        {
          "anonymous": false,
          "inputs": [
            {
              "indexed": true,
              "internalType": "uint256",
              "name": "avatarID",
              "type": "uint256"
            },
            {
              "indexed": true,
              "internalType": "uint64",
              "name": "epoch",
              "type": "uint64"
            },
            {
              "indexed": true,
              "internalType": "uint64",
              "name": "zone",
              "type": "uint64"
            },
            {
              "indexed": false,
              "internalType": "uint64",
              "name": "newPosition",
              "type": "uint64"
            }
          ],
          "name": "EnteredTheGame",
          "type": "event"
        },
        {
          "anonymous": false,
          "inputs": [
            {
              "indexed": true,
              "internalType": "uint256",
              "name": "avatarID",
              "type": "uint256"
            },
            {
              "indexed": true,
              "internalType": "uint64",
              "name": "epoch",
              "type": "uint64"
            },
            {
              "indexed": true,
              "internalType": "uint64",
              "name": "zoneWhenLeaving",
              "type": "uint64"
            },
            {
              "indexed": false,
              "internalType": "uint64",
              "name": "positionWhenLeaving",
              "type": "uint64"
            }
          ],
          "name": "LeftTheGame",
          "type": "event"
        },
        {
          "anonymous": false,
          "inputs": [
            {
              "indexed": true,
              "internalType": "uint256",
              "name": "avatarID",
              "type": "uint256"
            },
            {
              "indexed": false,
              "internalType": "uint64",
              "name": "epoch",
              "type": "uint64"
            },
            {
              "indexed": false,
              "internalType": "bytes24",
              "name": "commitmentHash",
              "type": "bytes24"
            }
          ],
          "name": "PreviousCommitmentNotRevealedEvent",
          "type": "event"
        },
        {
          "inputs": [
            {
              "internalType": "uint256",
              "name": "avatarID",
              "type": "uint256"
            }
          ],
          "name": "cancelCommit",
          "outputs": [],
          "stateMutability": "nonpayable",
          "type": "function"
        },
        {
          "inputs": [
            {
              "internalType": "uint256",
              "name": "avatarID",
              "type": "uint256"
            },
            {
              "internalType": "bytes24",
              "name": "commitmentHash",
              "type": "bytes24"
            },
            {
              "internalType": "address payable",
              "name": "payee",
              "type": "address"
            }
          ],
          "name": "commit",
          "outputs": [],
          "stateMutability": "payable",
          "type": "function"
        }
      ],
      "address": "0xead13819a29a979bdbfe5dc99e7099f1808ba7dc",
      "startBlock": 30140321
    },
    "Game_Implementation_Router_Deposit_Route": {
      "abi": [
        {
          "inputs": [
            {
              "components": [
                {
                  "internalType": "uint256",
                  "name": "startTime",
                  "type": "uint256"
                },
                {
                  "internalType": "uint256",
                  "name": "commitPhaseDuration",
                  "type": "uint256"
                },
                {
                  "internalType": "uint256",
                  "name": "revealPhaseDuration",
                  "type": "uint256"
                },
                {
                  "internalType": "contract ITime",
                  "name": "time",
                  "type": "address"
                },
                {
                  "internalType": "contract IERC721",
                  "name": "avatars",
                  "type": "address"
                },
                {
                  "internalType": "uint256",
                  "name": "numMoves",
                  "type": "uint256"
                }
              ],
              "internalType": "struct UsingGameTypes.Config",
              "name": "config",
              "type": "tuple"
            }
          ],
          "stateMutability": "nonpayable",
          "type": "constructor"
        },
        {
          "inputs": [
            {
              "internalType": "uint256",
              "name": "avatarID",
              "type": "uint256"
            }
          ],
          "name": "AvatarAlreadyInGame",
          "type": "error"
        },
        {
          "inputs": [
            {
              "internalType": "uint256",
              "name": "avatarID",
              "type": "uint256"
            }
          ],
          "name": "AvatarIsDead",
          "type": "error"
        },
        {
          "inputs": [
            {
              "internalType": "uint256",
              "name": "avatarID",
              "type": "uint256"
            }
          ],
          "name": "AvatarNotAvailable",
          "type": "error"
        },
        {
          "inputs": [
            {
              "internalType": "uint256",
              "name": "avatarID",
              "type": "uint256"
            }
          ],
          "name": "AvatarNotInGame",
          "type": "error"
        },
        {
          "inputs": [
            {
              "internalType": "uint256",
              "name": "avatarID",
              "type": "uint256"
            }
          ],
          "name": "AvatarNotReady",
          "type": "error"
        },
        {
          "inputs": [
            {
              "internalType": "uint256",
              "name": "avatarID",
              "type": "uint256"
            }
          ],
          "name": "AvatarStillInGame",
          "type": "error"
        },
        {
          "inputs": [
            {
              "internalType": "uint64",
              "name": "epoch",
              "type": "uint64"
            }
          ],
          "name": "CanStillReveal",
          "type": "error"
        },
        {
          "inputs": [],
          "name": "CommitmentHashNotMatching",
          "type": "error"
        },
        {
          "inputs": [],
          "name": "GameNotStarted",
          "type": "error"
        },
        {
          "inputs": [],
          "name": "ImpossibleConfiguration",
          "type": "error"
        },
        {
          "inputs": [
            {
              "internalType": "uint64",
              "name": "epoch",
              "type": "uint64"
            }
          ],
          "name": "InCommitmentPhase",
          "type": "error"
        },
        {
          "inputs": [
            {
              "internalType": "uint64",
              "name": "epoch",
              "type": "uint64"
            }
          ],
          "name": "InRevealPhase",
          "type": "error"
        },
        {
          "inputs": [],
          "name": "InvalidData",
          "type": "error"
        },
        {
          "inputs": [
            {
              "internalType": "uint64",
              "name": "expectedEpoch",
              "type": "uint64"
            },
            {
              "internalType": "uint64",
              "name": "epochGiven",
              "type": "uint64"
            }
          ],
          "name": "InvalidEpoch",
          "type": "error"
        },
        {
          "inputs": [],
          "name": "NoCommitmentToCancel",
          "type": "error"
        },
        {
          "inputs": [
            {
              "internalType": "address",
              "name": "account",
              "type": "address"
            }
          ],
          "name": "NotAuthorizedController",
          "type": "error"
        },
        {
          "inputs": [
            {
              "internalType": "address",
              "name": "account",
              "type": "address"
            }
          ],
          "name": "NotAuthorizedOwner",
          "type": "error"
        },
        {
          "inputs": [],
          "name": "NothingToReveal",
          "type": "error"
        },
        {
          "inputs": [],
          "name": "OnlyAvatarsAreAccepted",
          "type": "error"
        },
        {
          "inputs": [],
          "name": "PreviousCommitmentNotRevealed",
          "type": "error"
        },
        {
          "inputs": [
            {
              "internalType": "uint64",
              "name": "position",
              "type": "uint64"
            }
          ],
          "name": "UnableToExitFromThisPosition",
          "type": "error"
        },
        {
          "anonymous": false,
          "inputs": [
            {
              "indexed": true,
              "internalType": "uint256",
              "name": "avatarID",
              "type": "uint256"
            },
            {
              "indexed": true,
              "internalType": "address",
              "name": "owner",
              "type": "address"
            },
            {
              "indexed": false,
              "internalType": "address",
              "name": "controller",
              "type": "address"
            }
          ],
          "name": "AvatarDeposited",
          "type": "event"
        },
        {
          "anonymous": false,
          "inputs": [
            {
              "indexed": true,
              "internalType": "uint256",
              "name": "avatarID",
              "type": "uint256"
            }
          ],
          "name": "AvatarWithdrawn",
          "type": "event"
        },
        {
          "anonymous": false,
          "inputs": [
            {
              "indexed": true,
              "internalType": "uint256",
              "name": "avatarID",
              "type": "uint256"
            },
            {
              "indexed": true,
              "internalType": "uint64",
              "name": "epoch",
              "type": "uint64"
            }
          ],
          "name": "CommitmentCancelled",
          "type": "event"
        },
        {
          "anonymous": false,
          "inputs": [
            {
              "indexed": true,
              "internalType": "uint256",
              "name": "avatarID",
              "type": "uint256"
            },
            {
              "indexed": true,
              "internalType": "uint64",
              "name": "epoch",
              "type": "uint64"
            },
            {
              "indexed": false,
              "internalType": "bytes24",
              "name": "commitmentHash",
              "type": "bytes24"
            }
          ],
          "name": "CommitmentMade",
          "type": "event"
        },
        {
          "anonymous": false,
          "inputs": [
            {
              "indexed": true,
              "internalType": "uint256",
              "name": "avatarID",
              "type": "uint256"
            },
            {
              "indexed": true,
              "internalType": "uint64",
              "name": "epoch",
              "type": "uint64"
            },
            {
              "indexed": true,
              "internalType": "uint64",
              "name": "zone",
              "type": "uint64"
            },
            {
              "indexed": false,
              "internalType": "bytes24",
              "name": "commitmentHash",
              "type": "bytes24"
            },
            {
              "components": [
                {
                  "internalType": "enum UsingGameTypes.ActionType",
                  "name": "actionType",
                  "type": "uint8"
                },
                {
                  "internalType": "uint128",
                  "name": "data",
                  "type": "uint128"
                }
              ],
              "indexed": false,
              "internalType": "struct UsingGameTypes.Action[]",
              "name": "actions",
              "type": "tuple[]"
            }
          ],
          "name": "CommitmentRevealed",
          "type": "event"
        },
        {
          "anonymous": false,
          "inputs": [
            {
              "indexed": true,
              "internalType": "uint256",
              "name": "avatarID",
              "type": "uint256"
            },
            {
              "indexed": true,
              "internalType": "uint64",
              "name": "epoch",
              "type": "uint64"
            }
          ],
          "name": "CommitmentVoid",
          "type": "event"
        },
        {
          "anonymous": false,
          "inputs": [
            {
              "indexed": true,
              "internalType": "uint256",
              "name": "avatarID",
              "type": "uint256"
            },
            {
              "indexed": true,
              "internalType": "uint64",
              "name": "epoch",
              "type": "uint64"
            },
            {
              "indexed": true,
              "internalType": "uint64",
              "name": "zone",
              "type": "uint64"
            },
            {
              "indexed": false,
              "internalType": "uint64",
              "name": "newPosition",
              "type": "uint64"
            }
          ],
          "name": "EnteredTheGame",
          "type": "event"
        },
        {
          "anonymous": false,
          "inputs": [
            {
              "indexed": true,
              "internalType": "uint256",
              "name": "avatarID",
              "type": "uint256"
            },
            {
              "indexed": true,
              "internalType": "uint64",
              "name": "epoch",
              "type": "uint64"
            },
            {
              "indexed": true,
              "internalType": "uint64",
              "name": "zoneWhenLeaving",
              "type": "uint64"
            },
            {
              "indexed": false,
              "internalType": "uint64",
              "name": "positionWhenLeaving",
              "type": "uint64"
            }
          ],
          "name": "LeftTheGame",
          "type": "event"
        },
        {
          "anonymous": false,
          "inputs": [
            {
              "indexed": true,
              "internalType": "uint256",
              "name": "avatarID",
              "type": "uint256"
            },
            {
              "indexed": false,
              "internalType": "uint64",
              "name": "epoch",
              "type": "uint64"
            },
            {
              "indexed": false,
              "internalType": "bytes24",
              "name": "commitmentHash",
              "type": "bytes24"
            }
          ],
          "name": "PreviousCommitmentNotRevealedEvent",
          "type": "event"
        },
        {
          "inputs": [
            {
              "internalType": "address",
              "name": "owner",
              "type": "address"
            },
            {
              "internalType": "uint256",
              "name": "startIndex",
              "type": "uint256"
            },
            {
              "internalType": "uint256",
              "name": "limit",
              "type": "uint256"
            }
          ],
          "name": "avatarsPerOwner",
          "outputs": [
            {
              "components": [
                {
                  "internalType": "address",
                  "name": "owner",
                  "type": "address"
                },
                {
                  "internalType": "uint256",
                  "name": "avatarID",
                  "type": "uint256"
                },
                {
                  "internalType": "bool",
                  "name": "inGame",
                  "type": "bool"
                },
                {
                  "internalType": "uint64",
                  "name": "position",
                  "type": "uint64"
                },
                {
                  "internalType": "uint64",
                  "name": "lastEpoch",
                  "type": "uint64"
                },
                {
                  "internalType": "uint8",
                  "name": "life",
                  "type": "uint8"
                }
              ],
              "internalType": "struct UsingGameTypes.PublicAvatar[]",
              "name": "avatarIDs",
              "type": "tuple[]"
            },
            {
              "internalType": "bool",
              "name": "more",
              "type": "bool"
            }
          ],
          "stateMutability": "view",
          "type": "function"
        },
        {
          "inputs": [
            {
              "internalType": "uint256",
              "name": "avatarID",
              "type": "uint256"
            },
            {
              "internalType": "address",
              "name": "controller",
              "type": "address"
            },
            {
              "internalType": "address payable",
              "name": "payee",
              "type": "address"
            }
          ],
          "name": "deposit",
          "outputs": [],
          "stateMutability": "payable",
          "type": "function"
        },
        {
          "inputs": [
            {
              "internalType": "address",
              "name": "",
              "type": "address"
            },
            {
              "internalType": "address",
              "name": "",
              "type": "address"
            },
            {
              "internalType": "uint256",
              "name": "tokenID",
              "type": "uint256"
            },
            {
              "internalType": "bytes",
              "name": "data",
              "type": "bytes"
            }
          ],
          "name": "onERC721Received",
          "outputs": [
            {
              "internalType": "bytes4",
              "name": "",
              "type": "bytes4"
            }
          ],
          "stateMutability": "nonpayable",
          "type": "function"
        },
        {
          "inputs": [
            {
              "internalType": "uint256",
              "name": "avatarID",
              "type": "uint256"
            },
            {
              "internalType": "address",
              "name": "to",
              "type": "address"
            }
          ],
          "name": "withdraw",
          "outputs": [],
          "stateMutability": "nonpayable",
          "type": "function"
        }
      ],
      "address": "0xc2c491eed64dfbf2ceee8004d6558ca62c0136a5",
      "startBlock": 30140319
    },
    "Game_Implementation_Router_Getters_Route": {
      "abi": [
        {
          "inputs": [
            {
              "components": [
                {
                  "internalType": "uint256",
                  "name": "startTime",
                  "type": "uint256"
                },
                {
                  "internalType": "uint256",
                  "name": "commitPhaseDuration",
                  "type": "uint256"
                },
                {
                  "internalType": "uint256",
                  "name": "revealPhaseDuration",
                  "type": "uint256"
                },
                {
                  "internalType": "contract ITime",
                  "name": "time",
                  "type": "address"
                },
                {
                  "internalType": "contract IERC721",
                  "name": "avatars",
                  "type": "address"
                },
                {
                  "internalType": "uint256",
                  "name": "numMoves",
                  "type": "uint256"
                }
              ],
              "internalType": "struct UsingGameTypes.Config",
              "name": "config",
              "type": "tuple"
            }
          ],
          "stateMutability": "nonpayable",
          "type": "constructor"
        },
        {
          "inputs": [
            {
              "internalType": "uint256",
              "name": "avatarID",
              "type": "uint256"
            }
          ],
          "name": "AvatarAlreadyInGame",
          "type": "error"
        },
        {
          "inputs": [
            {
              "internalType": "uint256",
              "name": "avatarID",
              "type": "uint256"
            }
          ],
          "name": "AvatarIsDead",
          "type": "error"
        },
        {
          "inputs": [
            {
              "internalType": "uint256",
              "name": "avatarID",
              "type": "uint256"
            }
          ],
          "name": "AvatarNotAvailable",
          "type": "error"
        },
        {
          "inputs": [
            {
              "internalType": "uint256",
              "name": "avatarID",
              "type": "uint256"
            }
          ],
          "name": "AvatarNotInGame",
          "type": "error"
        },
        {
          "inputs": [
            {
              "internalType": "uint256",
              "name": "avatarID",
              "type": "uint256"
            }
          ],
          "name": "AvatarNotReady",
          "type": "error"
        },
        {
          "inputs": [
            {
              "internalType": "uint256",
              "name": "avatarID",
              "type": "uint256"
            }
          ],
          "name": "AvatarStillInGame",
          "type": "error"
        },
        {
          "inputs": [
            {
              "internalType": "uint64",
              "name": "epoch",
              "type": "uint64"
            }
          ],
          "name": "CanStillReveal",
          "type": "error"
        },
        {
          "inputs": [],
          "name": "CommitmentHashNotMatching",
          "type": "error"
        },
        {
          "inputs": [],
          "name": "GameNotStarted",
          "type": "error"
        },
        {
          "inputs": [],
          "name": "ImpossibleConfiguration",
          "type": "error"
        },
        {
          "inputs": [
            {
              "internalType": "uint64",
              "name": "epoch",
              "type": "uint64"
            }
          ],
          "name": "InCommitmentPhase",
          "type": "error"
        },
        {
          "inputs": [
            {
              "internalType": "uint64",
              "name": "epoch",
              "type": "uint64"
            }
          ],
          "name": "InRevealPhase",
          "type": "error"
        },
        {
          "inputs": [],
          "name": "InvalidData",
          "type": "error"
        },
        {
          "inputs": [
            {
              "internalType": "uint64",
              "name": "expectedEpoch",
              "type": "uint64"
            },
            {
              "internalType": "uint64",
              "name": "epochGiven",
              "type": "uint64"
            }
          ],
          "name": "InvalidEpoch",
          "type": "error"
        },
        {
          "inputs": [],
          "name": "NoCommitmentToCancel",
          "type": "error"
        },
        {
          "inputs": [
            {
              "internalType": "address",
              "name": "account",
              "type": "address"
            }
          ],
          "name": "NotAuthorizedController",
          "type": "error"
        },
        {
          "inputs": [
            {
              "internalType": "address",
              "name": "account",
              "type": "address"
            }
          ],
          "name": "NotAuthorizedOwner",
          "type": "error"
        },
        {
          "inputs": [],
          "name": "NothingToReveal",
          "type": "error"
        },
        {
          "inputs": [],
          "name": "OnlyAvatarsAreAccepted",
          "type": "error"
        },
        {
          "inputs": [],
          "name": "PreviousCommitmentNotRevealed",
          "type": "error"
        },
        {
          "inputs": [
            {
              "internalType": "uint64",
              "name": "position",
              "type": "uint64"
            }
          ],
          "name": "UnableToExitFromThisPosition",
          "type": "error"
        },
        {
          "anonymous": false,
          "inputs": [
            {
              "indexed": true,
              "internalType": "uint256",
              "name": "avatarID",
              "type": "uint256"
            },
            {
              "indexed": true,
              "internalType": "address",
              "name": "owner",
              "type": "address"
            },
            {
              "indexed": false,
              "internalType": "address",
              "name": "controller",
              "type": "address"
            }
          ],
          "name": "AvatarDeposited",
          "type": "event"
        },
        {
          "anonymous": false,
          "inputs": [
            {
              "indexed": true,
              "internalType": "uint256",
              "name": "avatarID",
              "type": "uint256"
            }
          ],
          "name": "AvatarWithdrawn",
          "type": "event"
        },
        {
          "anonymous": false,
          "inputs": [
            {
              "indexed": true,
              "internalType": "uint256",
              "name": "avatarID",
              "type": "uint256"
            },
            {
              "indexed": true,
              "internalType": "uint64",
              "name": "epoch",
              "type": "uint64"
            }
          ],
          "name": "CommitmentCancelled",
          "type": "event"
        },
        {
          "anonymous": false,
          "inputs": [
            {
              "indexed": true,
              "internalType": "uint256",
              "name": "avatarID",
              "type": "uint256"
            },
            {
              "indexed": true,
              "internalType": "uint64",
              "name": "epoch",
              "type": "uint64"
            },
            {
              "indexed": false,
              "internalType": "bytes24",
              "name": "commitmentHash",
              "type": "bytes24"
            }
          ],
          "name": "CommitmentMade",
          "type": "event"
        },
        {
          "anonymous": false,
          "inputs": [
            {
              "indexed": true,
              "internalType": "uint256",
              "name": "avatarID",
              "type": "uint256"
            },
            {
              "indexed": true,
              "internalType": "uint64",
              "name": "epoch",
              "type": "uint64"
            },
            {
              "indexed": true,
              "internalType": "uint64",
              "name": "zone",
              "type": "uint64"
            },
            {
              "indexed": false,
              "internalType": "bytes24",
              "name": "commitmentHash",
              "type": "bytes24"
            },
            {
              "components": [
                {
                  "internalType": "enum UsingGameTypes.ActionType",
                  "name": "actionType",
                  "type": "uint8"
                },
                {
                  "internalType": "uint128",
                  "name": "data",
                  "type": "uint128"
                }
              ],
              "indexed": false,
              "internalType": "struct UsingGameTypes.Action[]",
              "name": "actions",
              "type": "tuple[]"
            }
          ],
          "name": "CommitmentRevealed",
          "type": "event"
        },
        {
          "anonymous": false,
          "inputs": [
            {
              "indexed": true,
              "internalType": "uint256",
              "name": "avatarID",
              "type": "uint256"
            },
            {
              "indexed": true,
              "internalType": "uint64",
              "name": "epoch",
              "type": "uint64"
            }
          ],
          "name": "CommitmentVoid",
          "type": "event"
        },
        {
          "anonymous": false,
          "inputs": [
            {
              "indexed": true,
              "internalType": "uint256",
              "name": "avatarID",
              "type": "uint256"
            },
            {
              "indexed": true,
              "internalType": "uint64",
              "name": "epoch",
              "type": "uint64"
            },
            {
              "indexed": true,
              "internalType": "uint64",
              "name": "zone",
              "type": "uint64"
            },
            {
              "indexed": false,
              "internalType": "uint64",
              "name": "newPosition",
              "type": "uint64"
            }
          ],
          "name": "EnteredTheGame",
          "type": "event"
        },
        {
          "anonymous": false,
          "inputs": [
            {
              "indexed": true,
              "internalType": "uint256",
              "name": "avatarID",
              "type": "uint256"
            },
            {
              "indexed": true,
              "internalType": "uint64",
              "name": "epoch",
              "type": "uint64"
            },
            {
              "indexed": true,
              "internalType": "uint64",
              "name": "zoneWhenLeaving",
              "type": "uint64"
            },
            {
              "indexed": false,
              "internalType": "uint64",
              "name": "positionWhenLeaving",
              "type": "uint64"
            }
          ],
          "name": "LeftTheGame",
          "type": "event"
        },
        {
          "anonymous": false,
          "inputs": [
            {
              "indexed": true,
              "internalType": "uint256",
              "name": "avatarID",
              "type": "uint256"
            },
            {
              "indexed": false,
              "internalType": "uint64",
              "name": "epoch",
              "type": "uint64"
            },
            {
              "indexed": false,
              "internalType": "bytes24",
              "name": "commitmentHash",
              "type": "bytes24"
            }
          ],
          "name": "PreviousCommitmentNotRevealedEvent",
          "type": "event"
        },
        {
          "inputs": [
            {
              "internalType": "uint256",
              "name": "avatarID",
              "type": "uint256"
            }
          ],
          "name": "getAvatar",
          "outputs": [
            {
              "components": [
                {
                  "internalType": "address",
                  "name": "owner",
                  "type": "address"
                },
                {
                  "internalType": "uint256",
                  "name": "avatarID",
                  "type": "uint256"
                },
                {
                  "internalType": "bool",
                  "name": "inGame",
                  "type": "bool"
                },
                {
                  "internalType": "uint64",
                  "name": "position",
                  "type": "uint64"
                },
                {
                  "internalType": "uint64",
                  "name": "lastEpoch",
                  "type": "uint64"
                },
                {
                  "internalType": "uint8",
                  "name": "life",
                  "type": "uint8"
                }
              ],
              "internalType": "struct UsingGameTypes.PublicAvatar",
              "name": "",
              "type": "tuple"
            }
          ],
          "stateMutability": "view",
          "type": "function"
        },
        {
          "inputs": [
            {
              "internalType": "uint64[]",
              "name": "zones",
              "type": "uint64[]"
            },
            {
              "internalType": "uint64",
              "name": "fromIndex",
              "type": "uint64"
            },
            {
              "internalType": "uint64",
              "name": "limit",
              "type": "uint64"
            }
          ],
          "name": "getAvatarsInMultipleZones",
          "outputs": [
            {
              "components": [
                {
                  "internalType": "address",
                  "name": "owner",
                  "type": "address"
                },
                {
                  "internalType": "uint256",
                  "name": "avatarID",
                  "type": "uint256"
                },
                {
                  "internalType": "bool",
                  "name": "inGame",
                  "type": "bool"
                },
                {
                  "internalType": "uint64",
                  "name": "position",
                  "type": "uint64"
                },
                {
                  "internalType": "uint64",
                  "name": "lastEpoch",
                  "type": "uint64"
                },
                {
                  "internalType": "uint8",
                  "name": "life",
                  "type": "uint8"
                }
              ],
              "internalType": "struct UsingGameTypes.PublicAvatar[]",
              "name": "avatars",
              "type": "tuple[]"
            },
            {
              "internalType": "bool",
              "name": "more",
              "type": "bool"
            },
            {
              "internalType": "uint64",
              "name": "epoch",
              "type": "uint64"
            }
          ],
          "stateMutability": "view",
          "type": "function"
        },
        {
          "inputs": [
            {
              "internalType": "uint64",
              "name": "zone",
              "type": "uint64"
            },
            {
              "internalType": "uint64",
              "name": "fromIndex",
              "type": "uint64"
            },
            {
              "internalType": "uint64",
              "name": "limit",
              "type": "uint64"
            }
          ],
          "name": "getAvatarsInZone",
          "outputs": [
            {
              "components": [
                {
                  "internalType": "address",
                  "name": "owner",
                  "type": "address"
                },
                {
                  "internalType": "uint256",
                  "name": "avatarID",
                  "type": "uint256"
                },
                {
                  "internalType": "bool",
                  "name": "inGame",
                  "type": "bool"
                },
                {
                  "internalType": "uint64",
                  "name": "position",
                  "type": "uint64"
                },
                {
                  "internalType": "uint64",
                  "name": "lastEpoch",
                  "type": "uint64"
                },
                {
                  "internalType": "uint8",
                  "name": "life",
                  "type": "uint8"
                }
              ],
              "internalType": "struct UsingGameTypes.PublicAvatar[]",
              "name": "avatars",
              "type": "tuple[]"
            },
            {
              "internalType": "bool",
              "name": "more",
              "type": "bool"
            },
            {
              "internalType": "uint64",
              "name": "epoch",
              "type": "uint64"
            }
          ],
          "stateMutability": "view",
          "type": "function"
        },
        {
          "inputs": [
            {
              "internalType": "uint256",
              "name": "avatarID",
              "type": "uint256"
            }
          ],
          "name": "getCommitment",
          "outputs": [
            {
              "components": [
                {
                  "internalType": "bytes24",
                  "name": "hash",
                  "type": "bytes24"
                },
                {
                  "internalType": "uint64",
                  "name": "epoch",
                  "type": "uint64"
                }
              ],
              "internalType": "struct UsingGameTypes.Commitment",
              "name": "commitment",
              "type": "tuple"
            }
          ],
          "stateMutability": "view",
          "type": "function"
        },
        {
          "inputs": [],
          "name": "getConfig",
          "outputs": [
            {
              "components": [
                {
                  "internalType": "uint256",
                  "name": "startTime",
                  "type": "uint256"
                },
                {
                  "internalType": "uint256",
                  "name": "commitPhaseDuration",
                  "type": "uint256"
                },
                {
                  "internalType": "uint256",
                  "name": "revealPhaseDuration",
                  "type": "uint256"
                },
                {
                  "internalType": "contract ITime",
                  "name": "time",
                  "type": "address"
                },
                {
                  "internalType": "contract IERC721",
                  "name": "avatars",
                  "type": "address"
                },
                {
                  "internalType": "uint256",
                  "name": "numMoves",
                  "type": "uint256"
                }
              ],
              "internalType": "struct UsingGameTypes.Config",
              "name": "config",
              "type": "tuple"
            }
          ],
          "stateMutability": "view",
          "type": "function"
        },
        {
          "inputs": [],
          "name": "getEpoch",
          "outputs": [
            {
              "internalType": "uint64",
              "name": "epoch",
              "type": "uint64"
            },
            {
              "internalType": "bool",
              "name": "commiting",
              "type": "bool"
            }
          ],
          "stateMutability": "view",
          "type": "function"
        }
      ],
      "address": "0x011ab1c82c047e8e778158a61fa9ee48de3318cc",
      "startBlock": 30140317
    },
    "Game_Implementation_Router_Reveal_Route": {
      "abi": [
        {
          "inputs": [
            {
              "components": [
                {
                  "internalType": "uint256",
                  "name": "startTime",
                  "type": "uint256"
                },
                {
                  "internalType": "uint256",
                  "name": "commitPhaseDuration",
                  "type": "uint256"
                },
                {
                  "internalType": "uint256",
                  "name": "revealPhaseDuration",
                  "type": "uint256"
                },
                {
                  "internalType": "contract ITime",
                  "name": "time",
                  "type": "address"
                },
                {
                  "internalType": "contract IERC721",
                  "name": "avatars",
                  "type": "address"
                },
                {
                  "internalType": "uint256",
                  "name": "numMoves",
                  "type": "uint256"
                }
              ],
              "internalType": "struct UsingGameTypes.Config",
              "name": "config",
              "type": "tuple"
            }
          ],
          "stateMutability": "nonpayable",
          "type": "constructor"
        },
        {
          "inputs": [
            {
              "internalType": "uint256",
              "name": "avatarID",
              "type": "uint256"
            }
          ],
          "name": "AvatarAlreadyInGame",
          "type": "error"
        },
        {
          "inputs": [
            {
              "internalType": "uint256",
              "name": "avatarID",
              "type": "uint256"
            }
          ],
          "name": "AvatarIsDead",
          "type": "error"
        },
        {
          "inputs": [
            {
              "internalType": "uint256",
              "name": "avatarID",
              "type": "uint256"
            }
          ],
          "name": "AvatarNotAvailable",
          "type": "error"
        },
        {
          "inputs": [
            {
              "internalType": "uint256",
              "name": "avatarID",
              "type": "uint256"
            }
          ],
          "name": "AvatarNotInGame",
          "type": "error"
        },
        {
          "inputs": [
            {
              "internalType": "uint256",
              "name": "avatarID",
              "type": "uint256"
            }
          ],
          "name": "AvatarNotReady",
          "type": "error"
        },
        {
          "inputs": [
            {
              "internalType": "uint256",
              "name": "avatarID",
              "type": "uint256"
            }
          ],
          "name": "AvatarStillInGame",
          "type": "error"
        },
        {
          "inputs": [
            {
              "internalType": "uint64",
              "name": "epoch",
              "type": "uint64"
            }
          ],
          "name": "CanStillReveal",
          "type": "error"
        },
        {
          "inputs": [],
          "name": "CommitmentHashNotMatching",
          "type": "error"
        },
        {
          "inputs": [],
          "name": "GameNotStarted",
          "type": "error"
        },
        {
          "inputs": [],
          "name": "ImpossibleConfiguration",
          "type": "error"
        },
        {
          "inputs": [
            {
              "internalType": "uint64",
              "name": "epoch",
              "type": "uint64"
            }
          ],
          "name": "InCommitmentPhase",
          "type": "error"
        },
        {
          "inputs": [
            {
              "internalType": "uint64",
              "name": "epoch",
              "type": "uint64"
            }
          ],
          "name": "InRevealPhase",
          "type": "error"
        },
        {
          "inputs": [],
          "name": "InvalidData",
          "type": "error"
        },
        {
          "inputs": [
            {
              "internalType": "uint64",
              "name": "expectedEpoch",
              "type": "uint64"
            },
            {
              "internalType": "uint64",
              "name": "epochGiven",
              "type": "uint64"
            }
          ],
          "name": "InvalidEpoch",
          "type": "error"
        },
        {
          "inputs": [],
          "name": "NoCommitmentToCancel",
          "type": "error"
        },
        {
          "inputs": [
            {
              "internalType": "address",
              "name": "account",
              "type": "address"
            }
          ],
          "name": "NotAuthorizedController",
          "type": "error"
        },
        {
          "inputs": [
            {
              "internalType": "address",
              "name": "account",
              "type": "address"
            }
          ],
          "name": "NotAuthorizedOwner",
          "type": "error"
        },
        {
          "inputs": [],
          "name": "NothingToReveal",
          "type": "error"
        },
        {
          "inputs": [],
          "name": "OnlyAvatarsAreAccepted",
          "type": "error"
        },
        {
          "inputs": [],
          "name": "PreviousCommitmentNotRevealed",
          "type": "error"
        },
        {
          "inputs": [
            {
              "internalType": "uint256",
              "name": "value",
              "type": "uint256"
            },
            {
              "internalType": "uint256",
              "name": "length",
              "type": "uint256"
            }
          ],
          "name": "StringsInsufficientHexLength",
          "type": "error"
        },
        {
          "inputs": [
            {
              "internalType": "uint64",
              "name": "position",
              "type": "uint64"
            }
          ],
          "name": "UnableToExitFromThisPosition",
          "type": "error"
        },
        {
          "anonymous": false,
          "inputs": [
            {
              "indexed": true,
              "internalType": "uint256",
              "name": "avatarID",
              "type": "uint256"
            },
            {
              "indexed": true,
              "internalType": "address",
              "name": "owner",
              "type": "address"
            },
            {
              "indexed": false,
              "internalType": "address",
              "name": "controller",
              "type": "address"
            }
          ],
          "name": "AvatarDeposited",
          "type": "event"
        },
        {
          "anonymous": false,
          "inputs": [
            {
              "indexed": true,
              "internalType": "uint256",
              "name": "avatarID",
              "type": "uint256"
            }
          ],
          "name": "AvatarWithdrawn",
          "type": "event"
        },
        {
          "anonymous": false,
          "inputs": [
            {
              "indexed": true,
              "internalType": "uint256",
              "name": "avatarID",
              "type": "uint256"
            },
            {
              "indexed": true,
              "internalType": "uint64",
              "name": "epoch",
              "type": "uint64"
            }
          ],
          "name": "CommitmentCancelled",
          "type": "event"
        },
        {
          "anonymous": false,
          "inputs": [
            {
              "indexed": true,
              "internalType": "uint256",
              "name": "avatarID",
              "type": "uint256"
            },
            {
              "indexed": true,
              "internalType": "uint64",
              "name": "epoch",
              "type": "uint64"
            },
            {
              "indexed": false,
              "internalType": "bytes24",
              "name": "commitmentHash",
              "type": "bytes24"
            }
          ],
          "name": "CommitmentMade",
          "type": "event"
        },
        {
          "anonymous": false,
          "inputs": [
            {
              "indexed": true,
              "internalType": "uint256",
              "name": "avatarID",
              "type": "uint256"
            },
            {
              "indexed": true,
              "internalType": "uint64",
              "name": "epoch",
              "type": "uint64"
            },
            {
              "indexed": true,
              "internalType": "uint64",
              "name": "zone",
              "type": "uint64"
            },
            {
              "indexed": false,
              "internalType": "bytes24",
              "name": "commitmentHash",
              "type": "bytes24"
            },
            {
              "components": [
                {
                  "internalType": "enum UsingGameTypes.ActionType",
                  "name": "actionType",
                  "type": "uint8"
                },
                {
                  "internalType": "uint128",
                  "name": "data",
                  "type": "uint128"
                }
              ],
              "indexed": false,
              "internalType": "struct UsingGameTypes.Action[]",
              "name": "actions",
              "type": "tuple[]"
            }
          ],
          "name": "CommitmentRevealed",
          "type": "event"
        },
        {
          "anonymous": false,
          "inputs": [
            {
              "indexed": true,
              "internalType": "uint256",
              "name": "avatarID",
              "type": "uint256"
            },
            {
              "indexed": true,
              "internalType": "uint64",
              "name": "epoch",
              "type": "uint64"
            }
          ],
          "name": "CommitmentVoid",
          "type": "event"
        },
        {
          "anonymous": false,
          "inputs": [
            {
              "indexed": true,
              "internalType": "uint256",
              "name": "avatarID",
              "type": "uint256"
            },
            {
              "indexed": true,
              "internalType": "uint64",
              "name": "epoch",
              "type": "uint64"
            },
            {
              "indexed": true,
              "internalType": "uint64",
              "name": "zone",
              "type": "uint64"
            },
            {
              "indexed": false,
              "internalType": "uint64",
              "name": "newPosition",
              "type": "uint64"
            }
          ],
          "name": "EnteredTheGame",
          "type": "event"
        },
        {
          "anonymous": false,
          "inputs": [
            {
              "indexed": false,
              "internalType": "bytes4",
              "name": "selector",
              "type": "bytes4"
            },
            {
              "indexed": false,
              "internalType": "bytes",
              "name": "data",
              "type": "bytes"
            }
          ],
          "name": "Error",
          "type": "event"
        },
        {
          "anonymous": false,
          "inputs": [
            {
              "indexed": true,
              "internalType": "uint256",
              "name": "avatarID",
              "type": "uint256"
            },
            {
              "indexed": true,
              "internalType": "uint64",
              "name": "epoch",
              "type": "uint64"
            },
            {
              "indexed": true,
              "internalType": "uint64",
              "name": "zoneWhenLeaving",
              "type": "uint64"
            },
            {
              "indexed": false,
              "internalType": "uint64",
              "name": "positionWhenLeaving",
              "type": "uint64"
            }
          ],
          "name": "LeftTheGame",
          "type": "event"
        },
        {
          "anonymous": false,
          "inputs": [
            {
              "indexed": true,
              "internalType": "uint256",
              "name": "avatarID",
              "type": "uint256"
            },
            {
              "indexed": false,
              "internalType": "uint64",
              "name": "epoch",
              "type": "uint64"
            },
            {
              "indexed": false,
              "internalType": "bytes24",
              "name": "commitmentHash",
              "type": "bytes24"
            }
          ],
          "name": "PreviousCommitmentNotRevealedEvent",
          "type": "event"
        },
        {
          "inputs": [
            {
              "internalType": "uint256",
              "name": "avatarID",
              "type": "uint256"
            }
          ],
          "name": "acknowledgeMissedReveal",
          "outputs": [],
          "stateMutability": "nonpayable",
          "type": "function"
        },
        {
          "inputs": [
            {
              "internalType": "uint256",
              "name": "avatarID",
              "type": "uint256"
            },
            {
              "components": [
                {
                  "internalType": "enum UsingGameTypes.ActionType",
                  "name": "actionType",
                  "type": "uint8"
                },
                {
                  "internalType": "uint128",
                  "name": "data",
                  "type": "uint128"
                }
              ],
              "internalType": "struct UsingGameTypes.Action[]",
              "name": "actions",
              "type": "tuple[]"
            },
            {
              "internalType": "bytes32",
              "name": "secret",
              "type": "bytes32"
            },
            {
              "internalType": "address payable",
              "name": "payee",
              "type": "address"
            }
          ],
          "name": "reveal",
          "outputs": [],
          "stateMutability": "payable",
          "type": "function"
        }
      ],
      "address": "0xd2944ce5be41def8920a73c2a1da38720cbb9d3e",
      "startBlock": 30176500
    },
    "Game_Proxy": {
      "abi": [
        {
          "inputs": [
            {
              "internalType": "address",
              "name": "implementationAddress",
              "type": "address"
            },
            {
              "internalType": "address",
              "name": "ownerAddress",
              "type": "address"
            },
            {
              "internalType": "bytes",
              "name": "data",
              "type": "bytes"
            }
          ],
          "stateMutability": "payable",
          "type": "constructor"
        },
        {
          "anonymous": false,
          "inputs": [
            {
              "indexed": true,
              "internalType": "address",
              "name": "previousOwner",
              "type": "address"
            },
            {
              "indexed": true,
              "internalType": "address",
              "name": "newOwner",
              "type": "address"
            }
          ],
          "name": "OwnershipTransferred",
          "type": "event"
        },
        {
          "anonymous": false,
          "inputs": [
            {
              "indexed": true,
              "internalType": "address",
              "name": "previousImplementation",
              "type": "address"
            },
            {
              "indexed": true,
              "internalType": "address",
              "name": "newImplementation",
              "type": "address"
            }
          ],
          "name": "ProxyImplementationUpdated",
          "type": "event"
        },
        {
          "stateMutability": "payable",
          "type": "fallback"
        },
        {
          "inputs": [],
          "name": "owner",
          "outputs": [
            {
              "internalType": "address",
              "name": "",
              "type": "address"
            }
          ],
          "stateMutability": "view",
          "type": "function"
        },
        {
          "inputs": [
            {
              "internalType": "bytes4",
              "name": "id",
              "type": "bytes4"
            }
          ],
          "name": "supportsInterface",
          "outputs": [
            {
              "internalType": "bool",
              "name": "",
              "type": "bool"
            }
          ],
          "stateMutability": "view",
          "type": "function"
        },
        {
          "inputs": [
            {
              "internalType": "address",
              "name": "newOwner",
              "type": "address"
            }
          ],
          "name": "transferOwnership",
          "outputs": [],
          "stateMutability": "nonpayable",
          "type": "function"
        },
        {
          "inputs": [
            {
              "internalType": "address",
              "name": "newImplementation",
              "type": "address"
            }
          ],
          "name": "upgradeTo",
          "outputs": [],
          "stateMutability": "nonpayable",
          "type": "function"
        },
        {
          "inputs": [
            {
              "internalType": "address",
              "name": "newImplementation",
              "type": "address"
            },
            {
              "internalType": "bytes",
              "name": "data",
              "type": "bytes"
            }
          ],
          "name": "upgradeToAndCall",
          "outputs": [],
          "stateMutability": "payable",
          "type": "function"
        },
        {
          "stateMutability": "payable",
          "type": "receive"
        }
      ],
      "address": "0x7b27cc76ac4cd4e142b1bacee996941e12e95529",
      "startBlock": 30136240
    }
  },
  "name": "rise-testnet"
} as const;